
/**這個Adapter已經使用了autoThrowErrorFetch，不需要在使用時另外加上autoThrowError了 */
import { useEffect, useContext } from "react";
import { ApiVersionName, ResultObj, autoThrowErrorFetch, } from "../Domain";
import { ApiContext, useApi } from "../apiProvider";
import { ApiManagerBase, DefaultAdapterBase } from "../AdapterRule";
import {
    dotNet6DateTimeToDefaulFormat,
    dotNet6DateToDefaulFormat,
    defaultDateTimeToDotNet6Format,
    defaultDateToDotNet6Format,
} from "../function";

/** 新車訂單 api manager */
export const useOrderApi = () => {
    const apiManagerName = "OrderApiManager";
    const context = useContext(ApiContext);
    if (!context) throw new Error("OrderApiManager must be used within a ApiProvider");

    let { apiManagers, registerApiManager } = context;

    useEffect(() => {
        if (!apiManagers[apiManagerName]) {
            const newUserCareerRankApiManager = new OrderApiManager();
            newUserCareerRankApiManager.init().then((apiManager) => {
                registerApiManager(apiManagerName, apiManager);
            }).catch((e) => {
                console.error("ESD Error!", e);
            })
        }
    }, [apiManagers[apiManagerName]]);

    return useApi<OrderApiManager>(apiManagerName);
};

/** OrderApiManager 本人 */
export class OrderApiManager extends ApiManagerBase<OrderDefaultAdapter> implements OrderApiInterface {
    // 註冊相對應 adapter version
    apiManagerVersion: Record<ApiVersionName | "defaultAdapter", OrderDefaultAdapter> = {
        [ApiVersionName.DOT_NET_6]: new OrderDotNet6Adapter(),
        [ApiVersionName.DOT_NET_6_AM_N]: new OrderDotNet6Adapter(),//預設是 dotNet6，有需要才再另寫Adapter
        [ApiVersionName.FRAMEWORK]: new OrderFrameWorkAdapter(),
        defaultAdapter: new OrderDefaultAdapter(),
    }
    // 定義初始值
    adapter = this.apiManagerVersion.defaultAdapter;

    OrderCreate = this.checkDefaultHOF(async (obj: OrderCreateParams) => await this.adapter.OrderCreate(obj));
    OrderAllotment = this.checkDefaultHOF(async (obj: OrderAllotmentParams) => await this.adapter.OrderAllotment(obj));
    OrderReAllotment = this.checkDefaultHOF(async (obj: OrderReAllotmentParams) => await this.adapter.OrderReAllotment(obj));
    OrderAllotmentLogSearch = this.checkDefaultHOF(async (obj: OrderAllotmentLogSearchParams) => await this.adapter.OrderAllotmentLogSearch(obj));
    OrderCustodySearch = this.checkDefaultHOF(async (obj: OrderCustodySearchParams) => await this.adapter.OrderCustodySearch(obj));
    OrderCustodyLogSearch = this.checkDefaultHOF(async (obj: OrderCustodyLogSearchParams) => await this.adapter.OrderCustodyLogSearch(obj));
    OrderAbnormalReturn = this.checkDefaultHOF(async (obj: OrderAbnormalReturnParams) => await this.adapter.OrderAbnormalReturn(obj));
    OrderBlankReturn = this.checkDefaultHOF(async (obj: OrderBlankReturnParams) => await this.adapter.OrderBlankReturn(obj));
    OrderAudit = this.checkDefaultHOF(async (obj: OrderAuditParams) => await this.adapter.OrderAudit(obj));
    OrderTakeBack = this.checkDefaultHOF(async (obj: OrderTakeBackParams) => await this.adapter.OrderTakeBack(obj));
    OrderDetail = this.checkDefaultHOF(async (obj: OrderDetailParams) => await this.adapter.OrderDetail(obj));
    OrderSubscribeUpdate = this.checkDefaultHOF(async (obj: OrderSubscribeUpdateParams) => await this.adapter.OrderSubscribeUpdate(obj));
    OrderInsuranceUpdate = this.checkDefaultHOF(async (obj: OrderInsuranceUpdateParams) => await this.adapter.OrderInsuranceUpdate(obj));
    OrderUpdateLicensedDate = this.checkDefaultHOF(async (obj: OrderUpdateLicensedDateParams) => await this.adapter.OrderUpdateLicensedDate(obj));
    OrderDispatchCarSearch = this.checkDefaultHOF(async (obj: OrderDispatchCarSearchParams) => await this.adapter.OrderDispatchCarSearch(obj));
    OrderDispatchCar = this.checkDefaultHOF(async (obj: OrderDispatchCarParams) => await this.adapter.OrderDispatchCar(obj));
    OrderStopDispatch = this.checkDefaultHOF(async (obj: OrderStopDispatchParams) => await this.adapter.OrderStopDispatch(obj));
    OrderCalculate = this.checkDefaultHOF(async (obj: OrderCalculateParams) => await this.adapter.OrderCalculate(obj));
    OrderCarStockSearch = this.checkDefaultHOF(async (obj: OrderCarStockSearchParams) => await this.adapter.OrderCarStockSearch(obj));
    OrderCalculateSubsidy = this.checkDefaultHOF(async (obj: OrderCalculateSubsidyParams) => await this.adapter.OrderCalculateSubsidy(obj));
    OrderCalculateSubsidyBeforeUpdate = this.checkDefaultHOF(async (obj: OrderCalculateSubsidyBeforeUpdateParams) => await this.adapter.OrderCalculateSubsidyBeforeUpdate(obj));
    OrderSubsidyCarSearch = this.checkDefaultHOF(async (obj: OrderSubsidyCarSearchParams) => await this.adapter.OrderSubsidyCarSearch(obj));
    OrderBeforeReleaseCheck = this.checkDefaultHOF(async (obj: OrderBeforeReleaseCheckParams) => await this.adapter.OrderBeforeReleaseCheck(obj));
    OrderReleaseUpdateDate = this.checkDefaultHOF(async (obj: OrderReleaseUpdateDateParams) => await this.adapter.OrderReleaseUpdateDate(obj));
    OrderDeliveryInfoUpdate = this.checkDefaultHOF(async (obj: OrderDeliveryInfoUpdateParams) => await this.adapter.OrderDeliveryInfoUpdate(obj));
    OrderReleaseUpdateCustomer = this.checkDefaultHOF(async (obj: OrderReleaseUpdateCustomerParams) => await this.adapter.OrderReleaseUpdateCustomer(obj));
    OrderLicensedCheck = this.checkDefaultHOF(async (obj: OrderLicensedCheckParams) => await this.adapter.OrderLicensedCheck(obj));
    OrderReleaseCheck = this.checkDefaultHOF(async (obj: OrderReleaseCheckParams) => await this.adapter.OrderReleaseCheck(obj));
    OrderUpdateLicensedInfo = this.checkDefaultHOF(async (obj: OrderUpdateLicensedInfoParams) => await this.adapter.OrderUpdateLicensedInfo(obj));
    OrderSynchronizeSubscribe = this.checkDefaultHOF(async (obj: OrderSynchronizeSubscribeParams) => await this.adapter.OrderSynchronizeSubscribe(obj));
    OrderSynchronizeCarStock = this.checkDefaultHOF(async (obj: OrderSynchronizeCarStockParams) => await this.adapter.OrderSynchronizeCarStock(obj));
    OrderListOwn = this.checkDefaultHOF(async (obj: OrderListOwnParams) => await this.adapter.OrderListOwn(obj));
    OrderList = this.checkDefaultHOF(async (obj: OrderListParams) => await this.adapter.OrderList(obj));
    OrderDetailReport = this.checkDefaultHOF(async (obj: OrderDetailReportParams) => await this.adapter.OrderDetailReport(obj));
    OrderReport = this.checkDefaultHOF(async (obj: OrderReportParams) => await this.adapter.OrderReport(obj));
    OrderNewCarReceivableReport = this.checkDefaultHOF(async (obj: OrderNewCarReceivableReportParams) => await this.adapter.OrderNewCarReceivableReport(obj));
    OrderSubscribeSubmit = this.checkDefaultHOF(async (obj: OrderSubscribeSubmitParams) => await this.adapter.OrderSubscribeSubmit(obj));
    OrderOverDiscountSubmit = this.checkDefaultHOF(async (obj: OrderOverDiscountSubmitParams) => await this.adapter.OrderOverDiscountSubmit(obj));
    OrderSubscribeAudit = this.checkDefaultHOF(async (obj: OrderSubscribeAuditParams) => await this.adapter.OrderSubscribeAudit(obj));
}

/** 定義 adapter 需要有哪些function */
export interface OrderApiInterface {
    /** 批次新建空白訂單 */
    OrderCreate: (obj: OrderCreateParams) => Promise<ResultObj<null>>;
    /** 批次配發訂單(初次) */
    OrderAllotment: (obj: OrderAllotmentParams) => Promise<ResultObj<null>>;
    /** 批次配發訂單(非初次) */
    OrderReAllotment: (obj: OrderReAllotmentParams) => Promise<ResultObj<null>>;
    /** 訂單配發紀錄查詢 */
    OrderAllotmentLogSearch: (obj: OrderAllotmentLogSearchParams) => Promise<ResultObj<OrderAllotmentLogSearchResItem[]>>;
    /** 訂單保管查詢 */
    OrderCustodySearch: (obj: OrderCustodySearchParams) => Promise<ResultObj<OrderCustodySearchResItem>>;
    /** 訂單保管異動紀錄查詢 */
    OrderCustodyLogSearch: (obj: OrderCustodyLogSearchParams) => Promise<ResultObj<OrderCustodyLogSearchResItem[]>>;
    /** 訂單異常回報 */
    OrderAbnormalReturn: (obj: OrderAbnormalReturnParams) => Promise<ResultObj<null>>;
    /** 訂單空白繳回 */
    OrderBlankReturn: (obj: OrderBlankReturnParams) => Promise<ResultObj<null>>;
    /** 訂單稽核 */
    OrderAudit: (obj: OrderAuditParams) => Promise<ResultObj<null>>;
    /** 訂單收回 */
    OrderTakeBack: (obj: OrderTakeBackParams) => Promise<ResultObj<null>>;
    /** 訂單細項 */
    OrderDetail: (obj: OrderDetailParams) => Promise<ResultObj<OrderDetailResItem>>;
    /** 訂單受訂修改 */
    OrderSubscribeUpdate: (obj: OrderSubscribeUpdateParams) => Promise<ResultObj<OrderDetailResItem>>;
    /** 訂單保險修改 */
    OrderInsuranceUpdate: (obj: OrderInsuranceUpdateParams) => Promise<ResultObj<null>>;
    /** 訂單修改預計領牌日期 */
    OrderUpdateLicensedDate: (obj: OrderUpdateLicensedDateParams) => Promise<ResultObj<null>>;
    /** 訂單配車查詢 */
    OrderDispatchCarSearch: (obj: OrderDispatchCarSearchParams) => Promise<ResultObj<OrderDispatchCarSearchResItem[]>>;
    /** 訂單配車 或取消 */
    OrderDispatchCar: (obj: OrderDispatchCarParams) => Promise<ResultObj<OrderDispatchCarResItem>>;
    /** 訂單暫停配對 或取消 */
    OrderStopDispatch: (obj: OrderStopDispatchParams) => Promise<ResultObj<OrderStopDispatchResItem>>;
    /** 訂單計算公式 */
    OrderCalculate: (obj: OrderCalculateParams) => Promise<ResultObj<null>>;
    /** 訂單車型庫存檢查 */
    OrderCarStockSearch: (obj: OrderCarStockSearchParams) => Promise<ResultObj<OrderCarStockSearchResItem[]>>;
    /** 訂單計算補助 */
    OrderCalculateSubsidy: (obj: OrderCalculateSubsidyParams) => Promise<ResultObj<number>>;
    /** 計算補助(不更新訂單) */
    OrderCalculateSubsidyBeforeUpdate: (obj: OrderCalculateSubsidyBeforeUpdateParams) => Promise<ResultObj<OrderCalculateSubsidyBeforeUpdateResItem>>;
    /** 訂單補助車輛查詢 */
    OrderSubsidyCarSearch: (obj: OrderSubsidyCarSearchParams) => Promise<ResultObj<OrderSubsidyCarSearchResItem[]>>;
    /** 訂單受訂完成放行前檢查 */
    OrderBeforeReleaseCheck: (obj: OrderBeforeReleaseCheckParams) => Promise<ResultObj<OrderBeforeReleaseCheckResItem>>;
    /** 訂單放行日期們修改 */
    OrderReleaseUpdateDate: (obj: OrderReleaseUpdateDateParams) => Promise<ResultObj<OrderBeforeReleaseCheckResItem>>;
    /** 領牌應收資料 */
    OrderDeliveryInfoUpdate: (obj: OrderDeliveryInfoUpdateParams) => Promise<ResultObj<null>>;
    /** 訂單修改領牌人使用人資訊 */
    OrderReleaseUpdateCustomer: (obj: OrderReleaseUpdateCustomerParams) => Promise<ResultObj<null>>;
    /** 訂單確認領牌 */
    OrderLicensedCheck: (obj: OrderLicensedCheckParams) => Promise<ResultObj<OrderLicensedCheckResItem>>;
    /** 訂單確認放行 */
    OrderReleaseCheck: (obj: OrderReleaseCheckParams) => Promise<ResultObj<OrderReleaseCheckResItem>>;
    /** 訂單更新領牌資訊 */
    OrderUpdateLicensedInfo: (obj: OrderUpdateLicensedInfoParams) => Promise<ResultObj<OrderUpdateLicensedInfoResItem>>;
    /** 同步訂單更新受訂資訊 */
    OrderSynchronizeSubscribe: (obj: OrderSynchronizeSubscribeParams) => Promise<ResultObj<null>>;
    /** 同步訂單更新車源資訊 */
    OrderSynchronizeCarStock: (obj: OrderSynchronizeCarStockParams) => Promise<ResultObj<null>>;
    /** 訂單列表(自己的) */
    OrderListOwn: (obj: OrderListOwnParams) => Promise<ResultObj<OrderListOwnResItem[]>>;
    /** 訂單列表 */
    OrderList: (obj: OrderListParams) => Promise<ResultObj<OrderListResItem[]>>;
    /** 新車訂單報表 */
    OrderDetailReport: (obj: OrderDetailReportParams) => Promise<ResultObj<OrderDetailReportResItem[]>>;
    /** 新車配件報表 */
    OrderReport: (obj: OrderReportParams) => Promise<ResultObj<OrderReportResItem[]>>;
    /** 新車應收報表 */
    OrderNewCarReceivableReport: (obj: OrderNewCarReceivableReportParams) => Promise<ResultObj<OrderNewCarReceivableReportResItem[]>>;
    /** 訂單受訂送審 */
    OrderSubscribeSubmit: (obj: OrderSubscribeSubmitParams) => Promise<ResultObj<null>>;
    /** 訂單超折申請 */
    OrderOverDiscountSubmit: (obj: OrderOverDiscountSubmitParams) => Promise<ResultObj<null>>;
    /** 審核訂單受訂 */
    OrderSubscribeAudit: (obj: OrderSubscribeAuditParams) => Promise<ResultObj<null>>;
}

/** 預設 api adapter */
class OrderDefaultAdapter extends DefaultAdapterBase implements OrderApiInterface {
    OrderCreate = async (obj: OrderCreateParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderCreate', obj);
    OrderAllotment = async (obj: OrderAllotmentParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderAllotment', obj);
    OrderReAllotment = async (obj: OrderReAllotmentParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderReAllotment', obj);
    OrderAllotmentLogSearch = async (obj: OrderAllotmentLogSearchParams): Promise<ResultObj<OrderAllotmentLogSearchResItem[]>> => await autoThrowErrorFetch('Order/OrderAllotmentLogSearch', obj);
    OrderCustodySearch = async (obj: OrderCustodySearchParams): Promise<ResultObj<OrderCustodySearchResItem>> => await autoThrowErrorFetch('Order/OrderCustodySearch', obj);
    OrderCustodyLogSearch = async (obj: OrderCustodyLogSearchParams): Promise<ResultObj<OrderCustodyLogSearchResItem[]>> => await autoThrowErrorFetch('Order/OrderCustodyLogSearch', obj);
    OrderAbnormalReturn = async (obj: OrderAbnormalReturnParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderAbnormalReturn', obj);
    OrderBlankReturn = async (obj: OrderBlankReturnParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderBlankReturn', obj);
    OrderAudit = async (obj: OrderAuditParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderAudit', obj);
    OrderTakeBack = async (obj: OrderTakeBackParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderTakeBack', obj);
    OrderDetail = async (obj: OrderDetailParams): Promise<ResultObj<OrderDetailResItem>> => await autoThrowErrorFetch('Order/OrderDetail', obj);
    OrderSubscribeUpdate = async (obj: OrderSubscribeUpdateParams): Promise<ResultObj<OrderDetailResItem>> => await autoThrowErrorFetch('Order/OrderSubscribeUpdate', obj);
    OrderInsuranceUpdate = async (obj: OrderInsuranceUpdateParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderInsuranceUpdate', obj);
    OrderUpdateLicensedDate = async (obj: OrderUpdateLicensedDateParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderUpdateLicensedDate', obj);
    OrderDispatchCarSearch = async (obj: OrderDispatchCarSearchParams): Promise<ResultObj<OrderDispatchCarSearchResItem[]>> => await autoThrowErrorFetch('Order/OrderDispatchCarSearch', obj);
    OrderDispatchCar = async (obj: OrderDispatchCarParams): Promise<ResultObj<OrderDispatchCarResItem>> => await autoThrowErrorFetch('Order/OrderDispatchCar', obj);
    OrderStopDispatch = async (obj: OrderStopDispatchParams): Promise<ResultObj<OrderStopDispatchResItem>> => await autoThrowErrorFetch('Order/OrderStopDispatch', obj);
    OrderCalculate = async (obj: OrderCalculateParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderCalculate', obj);
    OrderCarStockSearch = async (obj: OrderCarStockSearchParams): Promise<ResultObj<OrderCarStockSearchResItem[]>> => await autoThrowErrorFetch('Order/OrderCarStockSearch', obj);
    OrderCalculateSubsidy = async (obj: OrderCalculateSubsidyParams): Promise<ResultObj<number>> => await autoThrowErrorFetch('Order/OrderCalculateSubsidy', obj);
    OrderCalculateSubsidyBeforeUpdate = async (obj: OrderCalculateSubsidyBeforeUpdateParams): Promise<ResultObj<OrderCalculateSubsidyBeforeUpdateResItem>> => await autoThrowErrorFetch('Order/OrderCalculateSubsidyBeforeUpdate', obj);
    OrderSubsidyCarSearch = async (obj: OrderSubsidyCarSearchParams): Promise<ResultObj<OrderSubsidyCarSearchResItem[]>> => await autoThrowErrorFetch('Order/OrderSubsidyCarSearch', obj);
    OrderBeforeReleaseCheck = async (obj: OrderBeforeReleaseCheckParams): Promise<ResultObj<OrderBeforeReleaseCheckResItem>> => await autoThrowErrorFetch('Order/OrderBeforeReleaseCheck', obj);
    OrderReleaseUpdateDate = async (obj: OrderReleaseUpdateDateParams): Promise<ResultObj<OrderBeforeReleaseCheckResItem>> => await autoThrowErrorFetch('Order/OrderReleaseUpdateDate', obj);
    OrderDeliveryInfoUpdate = async (obj: OrderDeliveryInfoUpdateParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderDeliveryInfoUpdate', obj);
    OrderReleaseUpdateCustomer = async (obj: OrderReleaseUpdateCustomerParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderReleaseUpdateCustomer', obj);
    OrderLicensedCheck = async (obj: OrderLicensedCheckParams): Promise<ResultObj<OrderLicensedCheckResItem>> => await autoThrowErrorFetch('Order/OrderLicensedCheck', obj);
    OrderReleaseCheck = async (obj: OrderReleaseCheckParams): Promise<ResultObj<OrderReleaseCheckResItem>> => await autoThrowErrorFetch('Order/OrderReleaseCheck', obj);
    OrderUpdateLicensedInfo = async (obj: OrderUpdateLicensedInfoParams): Promise<ResultObj<OrderUpdateLicensedInfoResItem>> => await autoThrowErrorFetch('Order/OrderUpdateLicensedInfo', obj);
    OrderSynchronizeSubscribe = async (obj: OrderSynchronizeSubscribeParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderSynchronizeSubscribe', obj);
    OrderSynchronizeCarStock = async (obj: OrderSynchronizeCarStockParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderSynchronizeCarStock', obj);
    OrderListOwn = async (obj: OrderListOwnParams): Promise<ResultObj<OrderListOwnResItem[]>> => await autoThrowErrorFetch('Order/OrderListOwn', {
        ...obj,
        allotment_time_start: obj.allotment_time_start ? defaultDateTimeToDotNet6Format(obj.allotment_time_start) : null,
        allotment_time_end: obj.allotment_time_end ? defaultDateTimeToDotNet6Format(obj.allotment_time_end) : null,
        contract_date_start: obj.contract_date_start ? defaultDateTimeToDotNet6Format(obj.contract_date_start) : null,
        contract_date_end: obj.contract_date_end ? defaultDateTimeToDotNet6Format(obj.contract_date_end) : null,
        dispatch_car_time_start: obj.dispatch_car_time_start ? defaultDateTimeToDotNet6Format(obj.dispatch_car_time_start) : null,
        dispatch_car_time_end: obj.dispatch_car_time_end ? defaultDateTimeToDotNet6Format(obj.dispatch_car_time_end) : null,
        first_submit_time_start: obj.first_submit_time_start ? defaultDateTimeToDotNet6Format(obj.first_submit_time_start) : null,
        first_submit_time_end: obj.first_submit_time_end ? defaultDateTimeToDotNet6Format(obj.first_submit_time_end) : null,
    });
    OrderList = async (obj: OrderListParams): Promise<ResultObj<OrderListResItem[]>> => await autoThrowErrorFetch('Order/OrderList', obj);
    OrderDetailReport = async (obj: OrderDetailReportParams): Promise<ResultObj<OrderDetailReportResItem[]>> => await autoThrowErrorFetch('Order/OrderDetailReport', {
        ...obj,
        final_payment_check_status: obj.final_payment_check_status === "" ? undefined : obj.final_payment_check_status,
        order_status: obj.order_status === "" ? undefined : obj.order_status,
    });
    OrderReport = async (obj: OrderReportParams): Promise<ResultObj<OrderReportResItem[]>> => await autoThrowErrorFetch('Order/OrderReport', obj);
    OrderNewCarReceivableReport = async (obj: OrderNewCarReceivableReportParams): Promise<ResultObj<OrderNewCarReceivableReportResItem[]>> => await autoThrowErrorFetch('Order/OrderNewCarReceivableReport', obj);
    OrderSubscribeSubmit = async (obj: OrderSubscribeSubmitParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderSubscribeSubmit', obj);
    OrderOverDiscountSubmit = async (obj: OrderOverDiscountSubmitParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderOverDiscountSubmit', obj);
    OrderSubscribeAudit = async (obj: OrderSubscribeAuditParams): Promise<ResultObj<null>> => await autoThrowErrorFetch('Order/OrderSubscribeAudit', obj);
}

/** DotNet6 版 */
class OrderDotNet6Adapter extends OrderDefaultAdapter {

    // ─── 私有轉換 helper：OrderMainDetailResItem 日期欄位 ─────────────────
    private _cvOrderDetailMainDt = (dt: OrderMainDetailResItem | null | undefined): OrderMainDetailResItem | undefined => {
        if (!dt) return undefined;
        return {
            ...dt,
            // date-time → 系統格式
            cre_time: dotNet6DateTimeToDefaulFormat(dt.cre_time),
            upd_time: dotNet6DateTimeToDefaulFormat(dt.upd_time),
            licensed_check_time: dotNet6DateTimeToDefaulFormat(dt.licensed_check_time),
            release_check_time: dotNet6DateTimeToDefaulFormat(dt.release_check_time),
            abnormal_return_time: dotNet6DateTimeToDefaulFormat(dt.abnormal_return_time),
            audit_time: dotNet6DateTimeToDefaulFormat(dt.audit_time),
            allotment_time: dotNet6DateTimeToDefaulFormat(dt.allotment_time),
            dispatch_car_time: dotNet6DateTimeToDefaulFormat(dt.dispatch_car_time),
            accounting_check_time: dotNet6DateTimeToDefaulFormat(dt.accounting_check_time),
            invoice_check_time: dotNet6DateTimeToDefaulFormat(dt.invoice_check_time),
            first_submit_time: dotNet6DateTimeToDefaulFormat(dt.first_submit_time),
            first_audit_time: dotNet6DateTimeToDefaulFormat(dt.first_audit_time),
            cus_agree_time: dotNet6DateTimeToDefaulFormat(dt.cus_agree_time),
            final_payment_time: dotNet6DateTimeToDefaulFormat(dt.final_payment_time),
            final_payment_check_time: dotNet6DateTimeToDefaulFormat(dt.final_payment_check_time),
            custody_user_cre_time: dotNet6DateTimeToDefaulFormat(dt.custody_user_cre_time),
            licensed_check_endorse_user_cre_time: dotNet6DateTimeToDefaulFormat(dt.licensed_check_endorse_user_cre_time),
            release_check_endorse_user_cre_time: dotNet6DateTimeToDefaulFormat(dt.release_check_endorse_user_cre_time),
            potential_customer_cre_time: dotNet6DateTimeToDefaulFormat(dt.potential_customer_cre_time),
            PR_bonus_user_cre_time: dotNet6DateTimeToDefaulFormat(dt.PR_bonus_user_cre_time),
            // date → 系統格式
            contract_date: dotNet6DateToDefaulFormat(dt.contract_date),
            predict_licensed_date: dotNet6DateToDefaulFormat(dt.predict_licensed_date),
            licensed_date: dotNet6DateToDefaulFormat(dt.licensed_date),
            extraction_date: dotNet6DateToDefaulFormat(dt.extraction_date),
            predict_delivery_date: dotNet6DateToDefaulFormat(dt.predict_delivery_date),
            delivery_date: dotNet6DateToDefaulFormat(dt.delivery_date),
            orderer_birthday: dotNet6DateToDefaulFormat(dt.orderer_birthday),
            licenser_birthday: dotNet6DateToDefaulFormat(dt.licenser_birthday),
            user_birthday: dotNet6DateToDefaulFormat(dt.user_birthday),
            predict_recovery_date: dotNet6DateToDefaulFormat(dt.predict_recovery_date),
            loan_bank_insurance_date: dotNet6DateToDefaulFormat(dt.loan_bank_insurance_date),
            // 稽核流程細項 (嵌套)
            AuditDetails: dt.AuditDetails?.map(a => ({
                ...a,
                cre_time: dotNet6DateTimeToDefaulFormat(a.cre_time),
                upd_time: dotNet6DateTimeToDefaulFormat(a.upd_time),
                user_cre_time: dotNet6DateTimeToDefaulFormat(a.user_cre_time),
                audit_time: dotNet6DateTimeToDefaulFormat(a.audit_time),
            })),
        };
    };

    // ─── 私有轉換 helper：OrderDetailResItem 完整回應 ────────────────────
    private _cvOrderDetailRes = (res: ResultObj<OrderDetailResItem>): ResultObj<OrderDetailResItem> => {
        if (!res.success || !res.data) return res;
        return {
            ...res,
            data: {
                ...res.data,
                dt: this._cvOrderDetailMainDt(res.data.dt),
                dt_order_payment: res.data.dt_order_payment?.map(p => ({
                    ...p,
                    upd_time: dotNet6DateTimeToDefaulFormat(p.upd_time),
                    transfer_in_date: dotNet6DateToDefaulFormat(p.transfer_in_date),
                    check_receive_date: dotNet6DateToDefaulFormat(p.check_receive_date),
                    check_expired_date: dotNet6DateToDefaulFormat(p.check_expired_date),
                    innertransfer_out_date: dotNet6DateToDefaulFormat(p.innertransfer_out_date),
                    loan_bank_insurance_date: dotNet6DateToDefaulFormat(p.loan_bank_insurance_date),
                })),
                dt_order_subsidy: res.data.dt_order_subsidy?.map(s => ({
                    ...s,
                    upd_time: dotNet6DateTimeToDefaulFormat(s.upd_time),
                    first_submit_time: dotNet6DateTimeToDefaulFormat(s.first_submit_time),
                    licensed_date: dotNet6DateToDefaulFormat(s.licensed_date),
                })),
                dt_order_invoice: res.data.dt_order_invoice?.map(i => ({
                    ...i,
                    invoice_date: dotNet6DateToDefaulFormat(i.invoice_date),
                })),
            },
        };
    };

    // ─── 訂單配發紀錄查詢 ─────────────────────────────────────────────────
    OrderAllotmentLogSearch = async (obj: OrderAllotmentLogSearchParams): Promise<ResultObj<OrderAllotmentLogSearchResItem[]>> => {
        const res: ResultObj<OrderAllotmentLogSearchResItem[]> = await autoThrowErrorFetch('Order/OrderAllotmentLogSearch', {
            ...obj,
            allotment_time_start: defaultDateToDotNet6Format(obj.allotment_time_start),
            allotment_time_end: defaultDateToDotNet6Format(obj.allotment_time_end),
        });
        if (!res.success || !res.data) return res;
        return {
            ...res,
            data: res.data.map(item => ({
                ...item,
                allotment_time: dotNet6DateTimeToDefaulFormat(item.allotment_time),
            })),
        };
    };

    // ─── 訂單保管查詢 ─────────────────────────────────────────────────────
    OrderCustodySearch = async (obj: OrderCustodySearchParams): Promise<ResultObj<OrderCustodySearchResItem>> => {
        const res: ResultObj<OrderCustodySearchResItem> = await autoThrowErrorFetch('Order/OrderCustodySearch', {
            ...obj,
            allotment_time_start: defaultDateToDotNet6Format(obj.allotment_time_start),
            allotment_time_end: defaultDateToDotNet6Format(obj.allotment_time_end),
        });
        if (!res.success || !res.data) return res;
        return {
            ...res,
            data: {
                ...res.data,
                user_statistics: res.data.user_statistics?.map(u => ({
                    ...u,
                    latest_allotment_time: dotNet6DateTimeToDefaulFormat(u.latest_allotment_time),
                })),
                unit_statistics: res.data.unit_statistics?.map(u => ({
                    ...u,
                    latest_allotment_time: dotNet6DateTimeToDefaulFormat(u.latest_allotment_time),
                })),
            },
        };
    };

    // ─── 訂單細項 ─────────────────────────────────────────────────────────
    OrderDetail = async (obj: OrderDetailParams): Promise<ResultObj<OrderDetailResItem>> => {
        const res: ResultObj<OrderDetailResItem> = await autoThrowErrorFetch('Order/OrderDetail', obj);
        return this._cvOrderDetailRes(res);
    };

    // ─── 訂單受訂修改 ─────────────────────────────────────────────────────
    OrderSubscribeUpdate = async (obj: OrderSubscribeUpdateParams): Promise<ResultObj<OrderDetailResItem>> => {
        const res: ResultObj<OrderDetailResItem> = await autoThrowErrorFetch('Order/OrderSubscribeUpdate', {
            ...obj,
            contract_date: defaultDateToDotNet6Format(obj.contract_date),
            order_potential_customer: obj.order_potential_customer ? {
                ...obj.order_potential_customer,
                first_contact_date: defaultDateToDotNet6Format(obj.order_potential_customer.first_contact_date),
                birthday: defaultDateToDotNet6Format(obj.order_potential_customer.birthday),
                orderer_birthday: defaultDateToDotNet6Format(obj.order_potential_customer.orderer_birthday),
            } : undefined,
            order_loan: obj.order_loan ? {
                ...obj.order_loan,
                loan_bank_insurance_date: defaultDateToDotNet6Format(obj.order_loan.loan_bank_insurance_date),
            } : undefined,
            order_payment: obj.order_payment ? {
                ...obj.order_payment,
                order_payment_details: obj.order_payment.order_payment_details?.map(p => ({
                    ...p,
                    transfer_in_date: defaultDateToDotNet6Format(p.transfer_in_date),
                    check_receive_date: defaultDateToDotNet6Format(p.check_receive_date),
                    check_expired_date: defaultDateToDotNet6Format(p.check_expired_date),
                    innertransfer_out_date: defaultDateToDotNet6Format(p.innertransfer_out_date),
                    loan_bank_insurance_date: defaultDateToDotNet6Format(p.loan_bank_insurance_date),
                })),
            } : undefined,
        });
        return this._cvOrderDetailRes(res);
    };

    // ─── 訂單修改預計領牌日期 ─────────────────────────────────────────────
    OrderUpdateLicensedDate = async (obj: OrderUpdateLicensedDateParams): Promise<ResultObj<null>> =>
        await autoThrowErrorFetch('Order/OrderUpdateLicensedDate', {
            ...obj,
            predict_licensed_date: defaultDateToDotNet6Format(obj.predict_licensed_date),
        });

    // ─── 訂單配車查詢 ─────────────────────────────────────────────────────
    OrderDispatchCarSearch = async (obj: OrderDispatchCarSearchParams): Promise<ResultObj<OrderDispatchCarSearchResItem[]>> => {
        const res: ResultObj<OrderDispatchCarSearchResItem[]> = await autoThrowErrorFetch('Order/OrderDispatchCarSearch', obj);
        if (!res.success || !res.data) return res;
        return {
            ...res,
            data: res.data.map(item => ({
                ...item,
                leave_factory_date: dotNet6DateToDefaulFormat(item.leave_factory_date),
            })),
        };
    };

    // ─── 訂單配車 ─────────────────────────────────────────────────────────
    OrderDispatchCar = async (obj: OrderDispatchCarParams): Promise<ResultObj<OrderDispatchCarResItem>> => {
        const res: ResultObj<OrderDispatchCarResItem> = await autoThrowErrorFetch('Order/OrderDispatchCar', obj);
        if (!res.success || !res.data) return res;
        return {
            ...res,
            data: {
                ...res.data,
                dispatch_car_time: dotNet6DateTimeToDefaulFormat(res.data.dispatch_car_time),
            },
        };
    };

    // ─── 計算補助(不更新訂單) ─────────────────────────────────────────────
    OrderCalculateSubsidyBeforeUpdate = async (obj: OrderCalculateSubsidyBeforeUpdateParams): Promise<ResultObj<OrderCalculateSubsidyBeforeUpdateResItem>> =>
        await autoThrowErrorFetch('Order/OrderCalculateSubsidyBeforeUpdate', {
            ...obj,
            licensed_date: defaultDateTimeToDotNet6Format(obj.licensed_date),
        });

    // ─── 訂單補助車輛查詢 ─────────────────────────────────────────────────
    OrderSubsidyCarSearch = async (obj: OrderSubsidyCarSearchParams): Promise<ResultObj<OrderSubsidyCarSearchResItem[]>> =>
        await autoThrowErrorFetch('Order/OrderSubsidyCarSearch', {
            ...obj,
            licensed_date: defaultDateToDotNet6Format(obj.licensed_date),
        });

    // ─── 訂單放行日期們修改 ───────────────────────────────────────────────
    OrderReleaseUpdateDate = async (obj: OrderReleaseUpdateDateParams): Promise<ResultObj<OrderBeforeReleaseCheckResItem>> =>
        await autoThrowErrorFetch('Order/OrderReleaseUpdateDate', {
            ...obj,
            extraction_date: defaultDateTimeToDotNet6Format(obj.extraction_date),
            predict_delivery_date: defaultDateTimeToDotNet6Format(obj.predict_delivery_date),
            delivery_date: defaultDateTimeToDotNet6Format(obj.delivery_date),
        });

    // ─── 領牌應收資料 ─────────────────────────────────────────────────────
    OrderDeliveryInfoUpdate = async (obj: OrderDeliveryInfoUpdateParams): Promise<ResultObj<null>> =>
        await autoThrowErrorFetch('Order/OrderDeliveryInfoUpdate', {
            ...obj,
            predict_recovery_date: defaultDateTimeToDotNet6Format(obj.predict_recovery_date),
            predict_delivery_date: defaultDateTimeToDotNet6Format(obj.predict_delivery_date),
        });

    // ─── 訂單修改領牌人使用人資訊 ────────────────────────────────────────
    OrderReleaseUpdateCustomer = async (obj: OrderReleaseUpdateCustomerParams): Promise<ResultObj<null>> =>
        await autoThrowErrorFetch('Order/OrderReleaseUpdateCustomer', {
            ...obj,
            licenser_birthday: defaultDateToDotNet6Format(obj.licenser_birthday),
            user_birthday: defaultDateToDotNet6Format(obj.user_birthday),
        });

    // ─── 訂單確認領牌 ─────────────────────────────────────────────────────
    OrderLicensedCheck = async (obj: OrderLicensedCheckParams): Promise<ResultObj<OrderLicensedCheckResItem>> => {
        const res: ResultObj<OrderLicensedCheckResItem> = await autoThrowErrorFetch('Order/OrderLicensedCheck', obj);
        if (!res.success || !res.data) return res;
        return {
            ...res,
            data: {
                ...res.data,
                licensed_check_time: dotNet6DateTimeToDefaulFormat(res.data.licensed_check_time),
            },
        };
    };

    // ─── 訂單確認放行 ─────────────────────────────────────────────────────
    OrderReleaseCheck = async (obj: OrderReleaseCheckParams): Promise<ResultObj<OrderReleaseCheckResItem>> => {
        const res: ResultObj<OrderReleaseCheckResItem> = await autoThrowErrorFetch('Order/OrderReleaseCheck', obj);
        if (!res.success || !res.data) return res;
        return {
            ...res,
            data: {
                ...res.data,
                release_check_time: dotNet6DateTimeToDefaulFormat(res.data.release_check_time),
            },
        };
    };

    // ─── 訂單更新領牌資訊 ─────────────────────────────────────────────────
    OrderUpdateLicensedInfo = async (obj: OrderUpdateLicensedInfoParams): Promise<ResultObj<OrderUpdateLicensedInfoResItem>> => {
        const res: ResultObj<OrderUpdateLicensedInfoResItem> = await autoThrowErrorFetch('Order/OrderUpdateLicensedInfo', {
            ...obj,
            licensed_date: defaultDateTimeToDotNet6Format(obj.licensed_date),
        });
        if (!res.success || !res.data) return res;
        return {
            ...res,
            data: {
                ...res.data,
                licensed_date: dotNet6DateToDefaulFormat(res.data.licensed_date),
            },
        };
    };

    // ─── 同步訂單更新受訂資訊 ────────────────────────────────────────────
    OrderSynchronizeSubscribe = async (obj: OrderSynchronizeSubscribeParams): Promise<ResultObj<null>> =>
        await autoThrowErrorFetch('Order/OrderSynchronizeSubscribe', {
            ...obj,
            contract_date: defaultDateToDotNet6Format(obj.contract_date),
        });

    // ─── 訂單列表 ─────────────────────────────────────────────────────────
    OrderList = async (obj: OrderListParams): Promise<ResultObj<OrderListResItem[]>> =>
        await autoThrowErrorFetch('Order/OrderList', {
            ...obj,
            allotment_time_start: defaultDateTimeToDotNet6Format(obj.allotment_time_start),
            allotment_time_end: defaultDateTimeToDotNet6Format(obj.allotment_time_end),
            first_submit_time_start: defaultDateTimeToDotNet6Format(obj.first_submit_time_start),
            first_submit_time_end: defaultDateTimeToDotNet6Format(obj.first_submit_time_end),
            dispatch_car_time_start: defaultDateTimeToDotNet6Format(obj.dispatch_car_time_start),
            dispatch_car_time_end: defaultDateTimeToDotNet6Format(obj.dispatch_car_time_end),
        });

    // ─── 訂單列表(自己的) ─────────────────────────────────────────────────
    OrderListOwn = async (obj: OrderListOwnParams): Promise<ResultObj<OrderListOwnResItem[]>> =>
        await autoThrowErrorFetch('Order/OrderListOwn', {
            ...obj,
            allotment_time_start: obj.allotment_time_start ? defaultDateTimeToDotNet6Format(obj.allotment_time_start) : null,
            allotment_time_end: obj.allotment_time_end ? defaultDateTimeToDotNet6Format(obj.allotment_time_end) : null,
            contract_date_start: obj.contract_date_start ? defaultDateTimeToDotNet6Format(obj.contract_date_start) : null,
            contract_date_end: obj.contract_date_end ? defaultDateTimeToDotNet6Format(obj.contract_date_end) : null,
            dispatch_car_time_start: obj.dispatch_car_time_start ? defaultDateTimeToDotNet6Format(obj.dispatch_car_time_start) : null,
            dispatch_car_time_end: obj.dispatch_car_time_end ? defaultDateTimeToDotNet6Format(obj.dispatch_car_time_end) : null,
            first_submit_time_start: obj.first_submit_time_start ? defaultDateTimeToDotNet6Format(obj.first_submit_time_start) : null,
            first_submit_time_end: obj.first_submit_time_end ? defaultDateTimeToDotNet6Format(obj.first_submit_time_end) : null,
        });

    // ─── 新車訂單報表 ─────────────────────────────────────────────────────
    OrderDetailReport = async (obj: OrderDetailReportParams): Promise<ResultObj<OrderDetailReportResItem[]>> => {
        const res: ResultObj<OrderDetailReportResItem[]> = await autoThrowErrorFetch('Order/OrderDetailReport', {
            ...obj,
            final_payment_check_status: obj.final_payment_check_status === "" ? undefined : obj.final_payment_check_status,
            order_status: obj.order_status === "" ? undefined : obj.order_status,
            first_submit_time_start: defaultDateTimeToDotNet6Format(obj.first_submit_time_start),
            first_submit_time_end: defaultDateTimeToDotNet6Format(obj.first_submit_time_end),
            first_audit_time_start: defaultDateTimeToDotNet6Format(obj.first_audit_time_start),
            first_audit_time_end: defaultDateTimeToDotNet6Format(obj.first_audit_time_end),
            final_payment_time_start: defaultDateTimeToDotNet6Format(obj.final_payment_time_start),
            final_payment_time_end: defaultDateTimeToDotNet6Format(obj.final_payment_time_end),
            licensed_date_start: defaultDateTimeToDotNet6Format(obj.licensed_date_start),
            licensed_date_end: defaultDateTimeToDotNet6Format(obj.licensed_date_end),
        });
        if (!res.success || !res.data) return res;
        return {
            ...res,
            data: res.data.map(item => ({
                ...item,
                first_submit_time: dotNet6DateTimeToDefaulFormat(item.first_submit_time),
                first_audit_date: dotNet6DateToDefaulFormat(item.first_audit_date),
                licensed_date: dotNet6DateToDefaulFormat(item.licensed_date),
                final_licensed_date: dotNet6DateToDefaulFormat(item.final_licensed_date),
                final_payment_time: dotNet6DateTimeToDefaulFormat(item.final_payment_time),
            })),
        };
    };

    // ─── 新車配件報表 ─────────────────────────────────────────────────────
    OrderReport = async (obj: OrderReportParams): Promise<ResultObj<OrderReportResItem[]>> => {
        const res: ResultObj<OrderReportResItem[]> = await autoThrowErrorFetch('Order/OrderReport', {
            ...obj,
            licensed_check_time_start: defaultDateTimeToDotNet6Format(obj.licensed_check_time_start),
            licensed_check_time_end: defaultDateTimeToDotNet6Format(obj.licensed_check_time_end),
            first_audit_time_start: defaultDateToDotNet6Format(obj.first_audit_time_start),
            first_audit_time_end: defaultDateToDotNet6Format(obj.first_audit_time_end),
            final_payment_time_start: defaultDateTimeToDotNet6Format(obj.final_payment_time_start),
            final_payment_time_end: defaultDateTimeToDotNet6Format(obj.final_payment_time_end),
        });
        if (!res.success || !res.data) return res;
        return {
            ...res,
            data: res.data.map(item => ({
                ...item,
                final_payment_time: dotNet6DateTimeToDefaulFormat(item.final_payment_time),
                first_audit_time: dotNet6DateTimeToDefaulFormat(item.first_audit_time),
                final_licensed_date: dotNet6DateTimeToDefaulFormat(item.final_licensed_date),
            })),
        };
    };

    // ─── 新車應收報表 ─────────────────────────────────────────────────────
    OrderNewCarReceivableReport = async (obj: OrderNewCarReceivableReportParams): Promise<ResultObj<OrderNewCarReceivableReportResItem[]>> =>
        await autoThrowErrorFetch('Order/OrderNewCarReceivableReport', {
            ...obj,
            predict_recovery_date: defaultDateToDotNet6Format(obj.predict_recovery_date),
            predict_delivery_date: defaultDateToDotNet6Format(obj.predict_delivery_date),
            invoice_date: defaultDateToDotNet6Format(obj.invoice_date),
        });
}

// ─── Framework 版專用回傳型別（模組私有，不匯出）────────────────────────────

/** Framework OrderAllotmentLogSearch 回傳（中文 key）*/
interface FWAllotmentLogItem {
    最近配發日: string;
    最小序號: string;
    最大序號: string;
    持有數: string;
    空白數: string;
    使用數: string;
    異常數: string;
    // order: string; // 僅用於 framework，不使用
}

/** Framework OrderCustodySearch 回傳（中文 key 扁平陣列）*/
interface FWCustodySearchItem {
    custody_user_id: string;
    名稱: string;
    單位: string;
    最近配發日: string;
    最小序號: string;
    最大序號: string;
    持有數: string;
    空白數: string;
    使用數: string;
    異常數: string;
    // order: string;       // 僅用於 framework，不使用
    // user_cre_time: string; // 不使用
}

/** Framework OrderDetail / OrderSubscribeUpdate 回傳（dt 為陣列）*/
interface FWOrderDetailResItem extends Omit<OrderDetailResItem, 'dt'> {
    dt: OrderMainDetailResItem[] | OrderMainDetailResItem;
}

/** Framework OrderList 回傳（customer_cre_time 為 potential_customer_cre_time 舊欄位名稱）*/
interface FWOrderListResItem extends Omit<OrderListResItem, 'potential_customer_cre_time'> {
    customer_cre_time?: string;
}

/** Framework 版 */
class OrderFrameWorkAdapter extends OrderDefaultAdapter {

    // ─── 訂單配發紀錄查詢 ─────────────────────────────────────────────────
    OrderAllotmentLogSearch = async (obj: OrderAllotmentLogSearchParams): Promise<ResultObj<OrderAllotmentLogSearchResItem[]>> => {
        const rawRes: ResultObj<FWAllotmentLogItem[]> = await autoThrowErrorFetch('Order/OrderAllotmentLogSearch', obj);
        if (!rawRes.success || !rawRes.data) return rawRes as unknown as ResultObj<OrderAllotmentLogSearchResItem[]>;
        return {
            ...rawRes,
            data: rawRes.data.map(item => ({
                allotment_time: item['最近配發日'],
                min_order_number: Number(item['最小序號']),
                max_order_number: Number(item['最大序號']),
                total_count: Number(item['持有數']),
                blank_count: Number(item['空白數']),
                used_count: Number(item['使用數']),
                abnormal_count: Number(item['異常數']),
            })),
        } as unknown as ResultObj<OrderAllotmentLogSearchResItem[]>;
    };

    // ─── 訂單保管查詢 ─────────────────────────────────────────────────────
    OrderCustodySearch = async (obj: OrderCustodySearchParams): Promise<ResultObj<OrderCustodySearchResItem>> => {
        const rawRes: ResultObj<FWCustodySearchItem[] | string> = await autoThrowErrorFetch('Order/OrderCustodySearch', obj);
        if (!rawRes.success || !rawRes.data) return rawRes as unknown as ResultObj<OrderCustodySearchResItem>;
        // excel 模式回傳 string (檔案路徑)，直接透傳
        if (!Array.isArray(rawRes.data)) return rawRes as unknown as ResultObj<OrderCustodySearchResItem>;
        const mapItem = (item: FWCustodySearchItem) => ({
            unit_name: item['單位'],
            name: item['名稱'],
            latest_allotment_time: item['最近配發日'],
            min_order_number: Number(item['最小序號']),
            max_order_number: Number(item['最大序號']),
            total_count: Number(item['持有數']),
            blank_count: Number(item['空白數']),
            used_count: Number(item['使用數']),
            abnormal_count: Number(item['異常數']),
        });
        return {
            ...rawRes,
            data: {
                user_statistics: rawRes.data
                    .filter(item => item['名稱'] !== '總和')
                    .map(item => ({ ...mapItem(item), custody_user_id: item.custody_user_id })),
                unit_statistics: rawRes.data
                    .filter(item => item['名稱'] === '總和')
                    .map(item => mapItem(item)),
            },
        } as unknown as ResultObj<OrderCustodySearchResItem>;
    };

    // ─── 訂單細項 ─────────────────────────────────────────────────────────
    OrderDetail = async (obj: OrderDetailParams): Promise<ResultObj<OrderDetailResItem>> => {
        const rawRes: ResultObj<FWOrderDetailResItem> = await autoThrowErrorFetch('Order/OrderDetail', obj);
        if (!rawRes.success || !rawRes.data) return rawRes as unknown as ResultObj<OrderDetailResItem>;
        return {
            ...rawRes,
            data: {
                ...rawRes.data,
                dt: Array.isArray(rawRes.data.dt) ? rawRes.data.dt[0] : rawRes.data.dt,
            },
        } as unknown as ResultObj<OrderDetailResItem>;
    };

    // ─── 訂單受訂修改 ─────────────────────────────────────────────────────
    OrderSubscribeUpdate = async (obj: OrderSubscribeUpdateParams): Promise<ResultObj<OrderDetailResItem>> => {
        // Framework 使用 chance_number 而非 outer_id
        let potentialCustomer: Omit<PotentialCustomerUpdateFromOrder, 'outer_id'> & { chance_number?: string } | undefined;
        if (obj.order_potential_customer) {
            const { outer_id, ...rest } = obj.order_potential_customer;
            potentialCustomer = { ...rest, chance_number: outer_id };
        }
        const rawRes: ResultObj<FWOrderDetailResItem> = await autoThrowErrorFetch('Order/OrderSubscribeUpdate', {
            ...obj,
            order_potential_customer: potentialCustomer,
        });
        if (!rawRes.success || !rawRes.data) return rawRes as unknown as ResultObj<OrderDetailResItem>;
        return {
            ...rawRes,
            data: {
                ...rawRes.data,
                dt: Array.isArray(rawRes.data.dt) ? rawRes.data.dt[0] : rawRes.data.dt,
            },
        } as unknown as ResultObj<OrderDetailResItem>;
    };

    // ─── 訂單列表 ─────────────────────────────────────────────────────────────────
    OrderList = async (obj: OrderListParams): Promise<ResultObj<OrderListResItem[]>> => {
        const rawRes: ResultObj<FWOrderListResItem[]> = await autoThrowErrorFetch('Order/OrderList', obj);
        if (!rawRes.success || !rawRes.data) return rawRes as unknown as ResultObj<OrderListResItem[]>;
        return {
            ...rawRes,
            data: rawRes.data.map(item => {
                const { customer_cre_time, ...rest } = item;
                return {
                    ...rest,
                    potential_customer_cre_time: customer_cre_time ?? '',
                };
            }),
        } as unknown as ResultObj<OrderListResItem[]>;
    };
}

// ==================== 共用子物件型別 ====================

/** 訂單異常回報 子物件
 * @param order_id 訂單流水號
 * @param abnormal_return_status 異常回報狀態
 * @param abnormal_return_note 異常回報備註
 */
export interface OrderAbnormalReturnObj {
    order_id: string;
    abnormal_return_status: string;
    abnormal_return_note?: string;
}

/** 訂單空白繳回 子物件
 * @param order_id 訂單流水號
 * @param abnormal_return_note 異常回報備註
 */
export interface OrderBlankReturnObj {
    order_id: string;
    abnormal_return_note?: string;
}

/** 訂單稽核 子物件
 * @param order_id 訂單流水號
 * @param audit_status 稽核狀態
 * @param audit_note 稽核備註
 */
export interface OrderAuditObj {
    order_id: string;
    audit_status: string;
    audit_note?: string;
}

/** 訂單收回 子物件
 * @param order_id 訂單流水號
 * @param audit_note 稽核備註
 */
export interface OrderTakeBackObj {
    order_id: string;
    audit_note?: string;
}

/** 配件物件
 * @param stock_id 庫存流水號
 * @param commodity_id 商品流水號
 * @param label_big 大標籤
 * @param uc_id 單位換算流水號
 * @param ccad_id_1 自訂屬性細項流水號1
 * @param ccad_id_2 自訂屬性細項流水號2
 * @param need_calc_stock 是否計算庫存
 * @param component_type 配件類別
 * @param component_name 配件名稱
 * @param price 單價
 * @param count 數量
 * @param note 備註
 */
export interface OrderCarComponentObj {
    stock_id?: string;
    commodity_id: string;
    label_big?: string;
    uc_id: string;
    ccad_id_1: string;
    ccad_id_2: string;
    need_calc_stock: string;
    component_type?: string;
    component_name: string;
    price?: number;
    count?: number;
    note?: string;
}

/** 車輛物件
 * @param is_self_licensed 是否自領牌
 * @param is_car_limit 是否限定車
 * @param cs_id 車流水號
 * @param abnormal_sale_type 異常銷售種類
 * @param note 銷顧備註
 * @param PR_bonus_user_id 公關車交車獎金領受人
 * @param PR_bonus_price 公關車交車獎金
 * @param ctfp_id 車型規格定價流水號
 * @param ctep_id 車型外裝加價流水號
 * @param ctip_id 車型內裝加價流水號
 * @param year 年式 (僅用於Framework)
 * @param year_age 年份 (僅用於Framework)
 */
export interface OrderCarObj {
    is_self_licensed: string;
    is_car_limit: string;
    cs_id?: string;
    abnormal_sale_type?: string;
    note?: string;
    PR_bonus_user_id?: string;
    PR_bonus_price?: number;
    ctfp_id?: number;
    ctep_id?: number;
    ctip_id?: number;
    year?: string; // 僅用於Framework
    year_age?: string; // 僅用於Framework
}

/** 保險物件
 * @param insurance_id 保險流水號
 * @param insurance_name 保險名稱
 * @param insurance_price 保險報價金額
 * @param insurance_type 保險種類
 * @param insurance_type_name 保險種類名稱
 * @param insurance_company_id 保險公司流水號
 * @param insurance_company_code 保險公司代號
 * @param insurance_company_name 保險公司名稱
 * @param note 備註
 */
export interface OrderInsuranceObj {
    insurance_id?: string;
    insurance_name: string;
    insurance_price?: number;
    insurance_type?: string;
    insurance_type_name?: string;
    insurance_company_id?: string;
    insurance_company_code?: string;
    insurance_company_name?: string;
    note?: string;
}

/** 入金細項物件
 * @param isdeposit 是否訂金
 * @param payment 付款方式
 * @param transfer_out_bank 匯款轉出銀行
 * @param transfer_out_account 匯款轉出帳號
 * @param transfer_in_bank 匯款轉入銀行
 * @param transfer_in_account 匯款轉入帳號
 * @param transfer_in_date 匯款轉入日期
 * @param transfer_in_price 匯款入金金額
 * @param check_pay_bank 支票付款銀行
 * @param check_number 支票票號
 * @param check_receive_bank 支票貸收銀行
 * @param check_receive_date 支票貸收日期
 * @param check_expired_date 支票到期日
 * @param check_price 支票入金金額
 * @param swipe_in_bank 刷卡轉入銀行
 * @param swipe_in_account 刷卡轉入帳號
 * @param swipe_price 刷卡入金金額
 * @param swipe_handling_fee 刷卡手續費
 * @param innertransfer_out_bank 內轉轉出銀行
 * @param innertransfer_out_date 內轉轉出日期
 * @param innertransfer_out_price 內轉轉出金額
 * @param innertransfer_out_method 內轉轉出方式
 * @param innertransfer_summon_code 內轉轉出傳票號碼
 * @param note 備註
 * @param overcharge 溢收
 * @param loan_agency 貸款機構
 * @param loan_bank_insurance_date 貸款銀行預計對保日期
 * @param loan_bank_predict_price 貸款預計金額
 * @param loan_predict_subsidy_price 預估貸款補貼息
 * @param loan_company_subsidy_price 貸款公司補助補貼息
 * @param sales_advisor_loan_subsidy 銷顧獎金補貸款補貼息
 * @param loan_tenure 貸款期數
 */
export interface OrderPaymentDetail {
    isdeposit: string;
    payment: string;
    transfer_out_bank?: string;
    transfer_out_account?: string;
    transfer_in_bank?: string;
    transfer_in_account?: string;
    transfer_in_date?: string;
    transfer_in_price?: number;
    check_pay_bank?: string;
    check_number?: string;
    check_receive_bank?: string;
    check_receive_date?: string;
    check_expired_date?: string;
    check_price?: number;
    swipe_in_bank?: string;
    swipe_in_account?: string;
    swipe_price?: number;
    swipe_handling_fee?: number;
    innertransfer_out_bank?: string;
    innertransfer_out_date?: string;
    innertransfer_out_price?: number;
    innertransfer_out_method?: string;
    innertransfer_summon_code?: string;
    note?: string;
    overcharge?: number;
    loan_agency?: string;
    loan_bank_insurance_date?: string;
    loan_bank_predict_price?: number;
    loan_predict_subsidy_price?: number;
    loan_company_subsidy_price?: number;
    sales_advisor_loan_subsidy?: number;
    loan_tenure?: string;
}

/** 入金物件
 * @param company_rule 公司規範(最少訂金)
 * @param order_payment_details 訂單入金細項
 */
export interface OrderPaymentObj {
    company_rule?: number;
    order_payment_details?: OrderPaymentDetail[];
}

/** 貸款物件
 * @param loan_agency 貸款機構
 * @param loan_bank_insurance_date 貸款銀行預計對保日期
 * @param loan_bank_predict_price 貸款預計金額
 * @param loan_predict_subsidy_price 預估貸款補貼息
 * @param loan_company_subsidy_price 公司補助貸款補貼息可折
 */
export interface OrderLoanObj {
    loan_agency?: string;
    loan_bank_insurance_date?: string;
    loan_bank_predict_price?: number;
    loan_predict_subsidy_price?: number;
    loan_company_subsidy_price?: number;
}

/** 潛客更新物件 (受訂用)
 * @param potential_customer_id 潛客流水號
 * @param potential_customer_name 客戶姓名
 * @param outer_id 外部識別碼
 * @param gender 性別
 * @param phone1 電話1
 * @param phone2 電話2
 * @param identity_number 客戶身分證
 * @param cellphone 行動電話
 * @param address_contact 聯絡地址
 * @param email 電子郵件
 * @param first_contact_date 首次接觸日期
 * @param source 客戶來源
 * @param level 等級
 * @param birthday 生日
 * @param career 職業
 * @param note 備註
 * @param potential_is_orderer 潛客是否購買人
 * @param orderer_customer_name 訂購人名稱
 * @param orderer_identity_number 訂購人身分證
 * @param orderer_cellphone 訂購人電話
 * @param orderer_address_contact 訂購人地址
 * @param orderer_birthday 訂購人生日
 * @param orderer_email 訂購人信箱
 */
export interface PotentialCustomerUpdateFromOrder {
    potential_customer_id: string;
    potential_customer_name?: string;
    outer_id?: string;
    gender?: string;
    phone1?: string;
    phone2?: string;
    identity_number?: string;
    cellphone?: string;
    address_contact?: string;
    email?: string;
    first_contact_date?: string;
    source?: string;
    level?: string;
    birthday?: string;
    career?: string;
    note?: string;
    potential_is_orderer: string;
    orderer_customer_name: string;
    orderer_identity_number?: string;
    orderer_cellphone?: string;
    orderer_address_contact?: string;
    orderer_birthday?: string;
    orderer_email?: string;
}

/** 同步潛客更新物件
 * @param potential_customer_id 潛客流水號
 * @param orderer_customer_name 訂購人名稱
 * @param orderer_cellphone 訂購人電話
 * @param orderer_address_contact 訂購人地址
 */
export interface OrderSynchronizePotentialCustomerUpdate {
    potential_customer_id: string;
    orderer_customer_name: string;
    orderer_cellphone?: string;
    orderer_address_contact?: string;
}

/** 同步車輛物件
 * @param cs_id 車流水號
 * @param ctfp_id 車型規格定價流水號
 * @param ctep_id 車型外裝加價流水號
 * @param ctip_id 車型內裝加價流水號
 */
export interface OrderSynchronizeCar {
    cs_id?: string;
    ctfp_id?: number;
    ctep_id?: number;
    ctip_id?: number;
}

// ==================== 請求參數型別 ====================

/** 批次新建空白訂單 (參數)
 * @param order_number_start 訂單編號起
 * @param order_number_end 訂單編號迄
 */
export interface OrderCreateParams {
    order_number_start: string;
    order_number_end: string;
}

/** 批次配發訂單(初次) (參數)
 * @param custody_unit_id 保管單位
 * @param custody_user_id 保管人
 * @param order_number_start 訂單編號起
 * @param order_number_end 訂單編號迄
 */
export interface OrderAllotmentParams {
    custody_unit_id?: string;
    custody_user_id: string;
    order_number_start: string;
    order_number_end: string;
}

/** 批次配發訂單(非初次) (參數)
 * @param custody_unit_id 保管單位
 * @param custody_user_id 保管人
 * @param order_number_start 訂單編號起
 * @param order_number_end 訂單編號迄
 */
export interface OrderReAllotmentParams {
    custody_unit_id?: string;
    custody_user_id: string;
    order_number_start: string;
    order_number_end: string;
}

/** 訂單配發紀錄查詢 (參數)
 * @param allotment_time_start 配發日期起
 * @param allotment_time_end 配發日期迄
 * @param page 頁碼
 * @param num_per_page 一頁幾筆
 */
export interface OrderAllotmentLogSearchParams {
    allotment_time_start?: string;
    allotment_time_end?: string;
    page?: number;
    num_per_page?: number;
}

/** 訂單保管查詢 (參數)
 * @param allotment_time_start 領取日期起
 * @param allotment_time_end 領取日期迄
 * @param custody_user_ids 保管人(帳號編號)們
 * @param custody_unit_id 保管單位(據點)流水號
 * @param excel 是否匯出
 */
export interface OrderCustodySearchParams {
    allotment_time_start?: string;
    allotment_time_end?: string;
    custody_user_ids?: string[];
    custody_unit_id?: string;
    excel?: string;
}

/** 訂單保管異動紀錄查詢 (參數)
 * @param order_id 訂單流水號
 * @param page 頁碼
 * @param num_per_page 一頁幾筆
 */
export interface OrderCustodyLogSearchParams {
    order_id: string;
    page?: number;
    num_per_page?: number;
}

/** 訂單異常回報 (參數)
 * @param OrderAbnormalReturn_objs 異常回報物件列表
 */
export interface OrderAbnormalReturnParams {
    OrderAbnormalReturn_objs?: OrderAbnormalReturnObj[];
}

/** 訂單空白繳回 (參數)
 * @param OrderBlankReturn_objs 空白繳回物件列表
 */
export interface OrderBlankReturnParams {
    OrderBlankReturn_objs?: OrderBlankReturnObj[];
}

/** 訂單稽核 (參數)
 * @param OrderAudit_objs 稽核物件列表
 */
export interface OrderAuditParams {
    OrderAudit_objs?: OrderAuditObj[];
}

/** 訂單收回 (參數)
 * @param OrderTakeBack_objs 收回物件列表
 */
export interface OrderTakeBackParams {
    OrderTakeBack_objs?: OrderTakeBackObj[];
}

/** 訂單細項 (參數)
 * @param order_id 訂單流水號
 */
export interface OrderDetailParams {
    order_id: string;
}

/** 訂單受訂修改 (參數)
 * @param order_id 訂單流水號
 * @param autodms_order_number AutoDMS訂單編號
 * @param contract_date 簽約日期
 * @param order_potential_customer 潛客資訊
 * @param order_car 車輛資訊
 * @param order_components 配件列表
 * @param order_insurance 保險資訊
 * @param order_payment 入金資訊
 * @param order_loan 貸款資訊
 * @param predict_pay_price 約定現金交易車價
 * @param stop_dispatch 暫停配對狀態
 */
export interface OrderSubscribeUpdateParams {
    order_id: string;
    autodms_order_number?: string;
    contract_date?: string;
    order_potential_customer?: PotentialCustomerUpdateFromOrder;
    order_car?: OrderCarObj;
    order_components?: OrderCarComponentObj[];
    order_insurance?: OrderInsuranceObj;
    order_payment?: OrderPaymentObj;
    order_loan?: OrderLoanObj;
    predict_pay_price: number;
    stop_dispatch: string;
}

/** 訂單保險修改 (參數)
 * @param oi_id 保險系統編號
 * @param order_id 訂單流水號
 * @param order_insurance 保險資訊
 */
export interface OrderInsuranceUpdateParams {
    oi_id: string;
    order_id: string;
    order_insurance?: OrderInsuranceObj;
}

/** 訂單修改預計領牌日期 (參數)
 * @param order_id 訂單流水號
 * @param predict_licensed_date 預計領牌日期
 */
export interface OrderUpdateLicensedDateParams {
    order_id: string;
    predict_licensed_date?: string;
}

/** 訂單配車查詢 (參數)
 * @param order_id 訂單流水號
 */
export interface OrderDispatchCarSearchParams {
    order_id: string;
}

/** 訂單配車 或取消 (參數)
 * @param order_id 訂單流水號
 * @param cs_id 車流水號
 */
export interface OrderDispatchCarParams {
    order_id: string;
    cs_id?: string;
}

/** 訂單暫停配對 或取消 (參數)
 * @param order_id 訂單流水號
 * @param stop_dispatch 暫停配對狀態
 */
export interface OrderStopDispatchParams {
    order_id: string;
    stop_dispatch: string;
}

/** 訂單計算公式 (參數)
 * @param order_id 訂單流水號
 */
export interface OrderCalculateParams {
    order_id: string;
}

/** 訂單車型庫存檢查 (參數)
 * @param ctfp_id 車型規格定價流水號
 * @param ctep_id 車型外裝加價流水號
 * @param ctip_id 車型內裝加價流水號
 * @param order_id 訂單系統流水號
 */
export interface OrderCarStockSearchParams {
    ctfp_id: number;
    ctep_id: number;
    ctip_id: number;
    order_id?: string;
}

/** 訂單計算補助 (參數)
 * @param order_id 訂單流水號
 */
export interface OrderCalculateSubsidyParams {
    order_id: string;
}

/** 計算補助(不更新訂單) (參數)
 * @param order_id 訂單流水號
 * @param ct_id 車型流水號
 * @param ctf_id 車型規格流水號
 * @param year 年式
 * @param year_age 年份
 * @param cs_id 車流水號
 * @param loan_bank_predict_price 貸款預計金額
 * @param car_components 配件們
 * @param licensed_date 領牌日期
 * @param abnormal_sale_type 異常銷售種類
 * @param insurance_type 保險種類
 */
export interface OrderCalculateSubsidyBeforeUpdateParams {
    order_id: string;
    ct_id: number;
    ctf_id: number;
    year: number;
    year_age: number;
    cs_id?: string;
    loan_bank_predict_price?: number;
    car_components?: OrderCarComponentObj[];
    licensed_date?: string;
    abnormal_sale_type?: string;
    insurance_type?: string;
}

/** 訂單補助車輛查詢 (參數)
 * @param order_id 訂單流水號
 * @param ct_id 車型流水號
 * @param ctf_id 車型規格對照流水號
 * @param year 年式
 * @param year_age 年份
 * @param licensed_date 領牌日期
 * @param abnormal_sale_type 異常銷售種類
 */
export interface OrderSubsidyCarSearchParams {
    order_id: string;
    ct_id: number;
    ctf_id: number;
    year: number;
    year_age: number;
    licensed_date?: string;
    abnormal_sale_type?: string;
}

/** 訂單受訂完成放行前檢查 (參數)
 * @param order_id 訂單流水號
 */
export interface OrderBeforeReleaseCheckParams {
    order_id: string;
}

/** 訂單放行日期們修改 (參數)
 * @param order_id 訂單流水號
 * @param extraction_date 提車日期
 * @param predict_delivery_date 預計交車日期
 * @param delivery_date 交車日期
 */
export interface OrderReleaseUpdateDateParams {
    order_id: string;
    extraction_date?: string;
    predict_delivery_date?: string;
    delivery_date?: string;
}

/** 領牌應收資料 (參數)
 * @param order_id 領牌應收資料(訂單流水號)
 * @param predict_recovery_date 預計回收日期
 * @param delivery_note 交車備註
 * @param predict_delivery_date 預計交車日期
 */
export interface OrderDeliveryInfoUpdateParams {
    order_id: string;
    predict_recovery_date?: string;
    delivery_note?: string;
    predict_delivery_date?: string;
}

/** 訂單修改領牌人使用人資訊 (參數)
 * @param order_id 訂單流水號
 * @param licenser_is_orderer 領牌人是否購買人
 * @param licenser_customer_name 領牌人名稱
 * @param licenser_identity_number 領牌人身分證
 * @param licenser_cellphone 領牌人電話
 * @param licenser_address_contact 領牌人地址
 * @param licenser_birthday 領牌人生日
 * @param licenser_email 領牌人信箱
 * @param user_is_orderer 使用人是否購買人
 * @param user_customer_name 使用人名稱
 * @param user_identity_number 使用人身分證
 * @param user_cellphone 使用人電話
 * @param user_address_contact 使用人地址
 * @param user_birthday 使用人生日
 * @param user_email 使用人信箱
 */
export interface OrderReleaseUpdateCustomerParams {
    order_id: string;
    licenser_is_orderer: string;
    licenser_customer_name: string;
    licenser_identity_number?: string;
    licenser_cellphone?: string;
    licenser_address_contact?: string;
    licenser_birthday?: string;
    licenser_email?: string;
    user_is_orderer: string;
    user_customer_name: string;
    user_identity_number?: string;
    user_cellphone?: string;
    user_address_contact?: string;
    user_birthday?: string;
    user_email?: string;
}

/** 訂單確認領牌 (參數)
 * @param order_id 訂單流水號
 */
export interface OrderLicensedCheckParams {
    order_id: string;
}

/** 訂單確認放行 (參數)
 * @param order_id 訂單流水號
 */
export interface OrderReleaseCheckParams {
    order_id: string;
}

/** 訂單更新領牌資訊 (參數)
 * @param order_id 訂單流水號
 * @param licensed_date 領牌日期
 * @param license_plate 車牌號碼
 */
export interface OrderUpdateLicensedInfoParams {
    order_id: string;
    licensed_date?: string;
    license_plate?: string;
}

/** 同步訂單更新受訂資訊 (參數)
 * @param order_id 訂單流水號
 * @param autodms_order_number AutoDMS訂單號碼
 * @param contract_date 簽訂日期
 * @param note 備註
 * @param order_potential_customer 潛客資訊
 */
export interface OrderSynchronizeSubscribeParams {
    order_id: string;
    autodms_order_number?: string;
    contract_date?: string;
    note?: string;
    order_potential_customer?: OrderSynchronizePotentialCustomerUpdate;
}

/** 同步訂單更新車源資訊 (參數)
 * @param order_id 訂單流水號
 * @param order_car 車輛資訊
 */
export interface OrderSynchronizeCarStockParams {
    order_id: string;
    order_car?: OrderSynchronizeCar;
}

/** 訂單列表(自己的) (參數)
 * @param position_id 據點流水號
 * @param dispatch_car_time_start 配車時間起
 * @param dispatch_car_time_end 配車時間迄
 * @param custody_unit_id 保管單位(據點流水號)
 * @param custody_user_ids 保管人(帳號編號)們
 * @param is_final_payment_check 是否全款日確認
 * @param my_turn 是否輪到我審
 * @param order_number_start 訂單編號起
 * @param order_number_end 訂單編號迄
 * @param allotment_time_start 領取日期起
 * @param allotment_time_end 領取日期迄
 * @param first_submit_time_start 申請日期起
 * @param first_submit_time_end 申請日期迄
 * @param order_id 訂單系統編號
 * @param autodms_order_number AutoDMS訂單編號
 * @param statuses 審核狀態們
 * @param is_dispatched 車管是否已配車
 * @param stop_dispatch 是否暫停配對
 * @param is_release_check 是否確認放行
 * @param is_licensed_check 是否確認領牌
 * @param is_accounting_check 財務是否確認
 * @param is_invoice_check 是否發票確認
 * @param page 頁碼
 * @param num_per_page 一頁幾筆
 */
export interface OrderListOwnParams {
    position_id?: string;
    dispatch_car_time_start?: string;
    dispatch_car_time_end?: string;
    custody_unit_id?: string;
    custody_user_ids?: string[];
    is_final_payment_check?: string;
    my_turn?: string;
    order_number_start?: string;
    order_number_end?: string;
    allotment_time_start?: string;
    allotment_time_end?: string;
    first_submit_time_start?: string;
    first_submit_time_end?: string;
    order_id?: string;
    autodms_order_number?: string;
    statuses?: string[];
    is_dispatched?: string;
    stop_dispatch?: string;
    is_release_check?: string;
    is_licensed_check?: string;
    is_accounting_check?: string;
    is_invoice_check?: string;
    page?: number;
    num_per_page?: number;
    // 注意：以下欄位似乎只有特定經銷商有在用，先寫成可以不給的樣子
    SIDO_no?: string;
    license_plate?: string;
    contract_date_start?: string | null;
    contract_date_end?: string | null;
}

/**訂單列表(自己的) (回傳)
 *  @description 訂單列表(自己的) (回傳)
 *  @param custody_user_id 保管人(使用者)ID
 *  @param custody_user_name 保管人(使用者)名稱
 *  @param allotment_time 領取日
 *  @param audit_status 稽核狀態
 *  @param audit_note 稽核備註
 *  @param audit_time 稽核時間
 *  @param custody_unit_id 保官單位ID
 *  @param custody_unit_name 保官單位名稱
 *  @param order_id 訂單流水號
 *  @param order_number 訂單號碼
 *  @param abnormal_return_status 異常狀態
 */
export interface OrderListOwnResItem {
    abnormal_return_note: string;
    abnormal_return_status: string;
    abnormal_return_time: string;
    accounting_check_time: string;
    allotment_time: string;
    audit_note: string;
    audit_status: string;
    audit_time: string;
    autodms_order_number: string;
    contract_date: string;
    custody_unit_id: string;
    custody_unit_name: string;
    custody_user_id: string;
    custody_user_name: string;
    dispatch_car_time: string;
    first_audit_time: string;
    first_submit_time: string;
    invoice_check_time: string;
    is_accounting_check: string;
    is_dispatched: string;
    is_invoice_check: string;
    is_licensed_check: string;
    is_release_check: string;
    isabnormal: string;
    licensed_check_endorse_user_id: string;
    licensed_check_time: string;
    order_allotment_id: number;
    order_id: string;
    order_number: string;
    order_status: string;
    release_check_endorse_user_id: string;
    release_check_time: string;
    stop_dispatch: string;
    upd_time: string;
    user_cre_time: string;

    // 以下是補充欄位，因為有些經銷商會用到
    custody_user_cre_time: string;
    potential_customer_cre_time: string;
    potential_customer_name: string;
    final_payment_time: string;
    final_payment_check_time: string;
}

/** 訂單列表 (參數)
 * @param order_number_start 訂單編號起
 * @param order_number_end 訂單編號迄
 * @param position_id 據點流水號
 * @param allotment_time_start 領取日期起
 * @param allotment_time_end 領取日期迄
 * @param first_submit_time_start 申請日期起
 * @param first_submit_time_end 申請日期迄
 * @param dispatch_car_time_start 配車時間起
 * @param dispatch_car_time_end 配車時間迄
 * @param custody_unit_id 保管單位(據點流水號)
 * @param custody_user_ids 保管人(帳號編號)們
 * @param order_id 訂單流水號
 * @param autodms_order_number AutoDMS訂單編號
 * @param statuses 審核狀態們
 * @param is_dispatched 車管是否已配車
 * @param stop_dispatch 是否暫停配對
 * @param is_release_check 是否確認放行
 * @param is_licensed_check 是否確認領牌
 * @param is_accounting_check 財務是否確認
 * @param is_invoice_check 是否發票確認
 * @param is_final_payment_check 是否全款日確認
 * @param my_turn 是否輪到我審
 * @param page 頁碼
 * @param num_per_page 一頁幾筆
 */
export interface OrderListParams {
    order_number_start?: string;
    order_number_end?: string;
    position_id?: string;
    allotment_time_start?: string;
    allotment_time_end?: string;
    first_submit_time_start?: string;
    first_submit_time_end?: string;
    dispatch_car_time_start?: string;
    dispatch_car_time_end?: string;
    custody_unit_id?: string;
    custody_user_ids?: string[];
    order_id?: string;
    autodms_order_number?: string;
    statuses?: string[];
    is_dispatched?: string;
    stop_dispatch?: string;
    is_release_check?: string;
    is_licensed_check?: string;
    is_accounting_check?: string;
    is_invoice_check?: string;
    is_final_payment_check?: string;
    my_turn?: string;
    page?: number;
    num_per_page?: number;
}

/**
 * @description 訂單列表 (回傳)
 * @param order_id 訂單流水號
 * @param autodms_order_number AutoDMS訂單號碼
 * @param order_number 訂單號碼
 * @param order_status 審核狀態
 * @param contract_date 簽約日期
 * @param custody_unit_id 保管單位流水號
 * @param custody_unit_name 保管單位名稱
 * @param custody_user_id 保管人流水號
 * @param custody_user_name 保管人名稱
 * @param custody_user_cre_time 保管人建立時間
 * @param is_licensed_check 是否確認領牌
 * @param licensed_check_time 領牌確認時間
 * @param licensed_check_endorse_user_id 領牌背書人ID
 * @param is_release_check 是否確認放行
 * @param release_check_time 放行確認時間
 * @param release_check_endorse_user_id 放行背書人ID
 * @param isabnormal 是否異常
 * @param abnormal_return_status 異常回報狀態
 * @param abnormal_return_note 異常回報備註
 * @param abnormal_return_time 異常回報時間
 * @param audit_status 稽核狀態
 * @param audit_note 稽核備註
 * @param audit_time 稽核時間
 * @param order_allotment_id 訂單配發流水號
 * @param allotment_time 配發時間
 * @param first_submit_time 首次送審時間
 * @param first_audit_time 首次稽核時間
 * @param is_dispatched 是否已配車
 * @param dispatch_car_time 配車時間
 * @param stop_dispatch 是否暫停配對
 * @param is_accounting_check 財務是否確認
 * @param accounting_check_time 財務確認時間
 * @param is_invoice_check 是否發票確認
 * @param invoice_check_time 發票確認時間
 * @param potential_customer_cre_time 潛客建立時間
 * @param potential_customer_name 潛客姓名
 * @param final_payment_time 全款日(調整過的)
 * @param final_payment_check_time 全款日
 * @param audit_level 稽核層級 // 僅用於 framework
 * @param audit_level_ul_id 稽核層級用戶等級 // 僅用於 framework
 * @param user_cre_time 建立時間 // 僅用於 framework
 */
export interface OrderListResItem {
    order_id: string;
    autodms_order_number: string;
    order_number: string;
    order_status: string;
    contract_date: string;
    custody_unit_id: string;
    custody_unit_name: string;
    custody_user_id: string;
    custody_user_name: string;
    custody_user_cre_time: string;
    is_licensed_check: string;
    licensed_check_time: string;
    licensed_check_endorse_user_id: string;
    is_release_check: string;
    release_check_time: string;
    release_check_endorse_user_id: string;
    isabnormal: string;
    abnormal_return_status: string;
    abnormal_return_note: string;
    abnormal_return_time: string;
    audit_status: string;
    audit_note: string;
    audit_time: string;
    order_allotment_id: number;
    allotment_time: string;
    first_submit_time: string;
    first_audit_time: string;
    is_dispatched: string;
    dispatch_car_time: string;
    stop_dispatch: string;
    is_accounting_check: string;
    accounting_check_time: string;
    is_invoice_check: string;
    invoice_check_time: string;
    potential_customer_cre_time: string;
    potential_customer_name: string;
    final_payment_time: string;
    final_payment_check_time: string;
    /** 僅用於 framework */
    audit_level?: string;
    /** 僅用於 framework */
    audit_level_ul_id?: string;
    /** 僅用於 framework */
    user_cre_time: string;
    // 注意：以下欄位似乎只有特定經銷商有在用，先寫成可以不給的樣子
    SIDO_no?: string;
    license_plate?: string;
    orderer_customer_name?: string;
    user_customer_name?: string;
}

/** 新車訂單報表 (參數)
 * @param order_number 訂單編號
 * @param autodms_order_number AutoDMS訂單號碼
 * @param custody_name 申請者姓名
 * @param order_status 審核狀態
 * @param final_payment_check_status 財務全款狀態
 * @param first_submit_time_start 申請日期起
 * @param first_submit_time_end 申請日期迄
 * @param first_audit_time_start 審核通過日期起
 * @param first_audit_time_end 審核通過日期迄
 * @param final_payment_time_start 全款日期起
 * @param final_payment_time_end 全款日期迄
 * @param licensed_date_start 領牌日期起
 * @param licensed_date_end 領牌日期迄
 * @param excel 是否匯出
 * @param page 頁碼
 * @param num_per_page 一頁幾筆
 */
export interface OrderDetailReportParams {
    order_number?: string;
    autodms_order_number?: string;
    custody_name?: string;
    order_status?: string;
    final_payment_check_status?: string;
    first_submit_time_start?: string;
    first_submit_time_end?: string;
    first_audit_time_start?: string;
    first_audit_time_end?: string;
    licensed_date_start?: string;
    licensed_date_end?: string;
    final_payment_time_start?: string;
    final_payment_time_end?: string;
    excel?: string;
    page?: number;
    num_per_page?: number;
}

/** 新車配件報表 (參數)
 * @param licensed_check_time_start 領牌日期起
 * @param licensed_check_time_end 領牌日期迄
 * @param first_audit_time_start 審核日期起
 * @param first_audit_time_end 審核日期迄
 * @param final_payment_time_start 全款日期起
 * @param final_payment_time_end 全款日期迄
 * @param excel 是否匯出
 * @param page 頁碼
 * @param num_per_page 一頁幾筆
 */
export interface OrderReportParams {
    licensed_check_time_start?: string;
    licensed_check_time_end?: string;
    first_audit_time_start?: string;
    first_audit_time_end?: string;
    final_payment_time_start?: string;
    final_payment_time_end?: string;
    excel?: string;
    page?: number;
    num_per_page?: number;
}

/** 新車應收報表 (參數)
 * @param order_number 訂單編號
 * @param autodms_order_number AutoDMS訂單號碼
 * @param custody_unit_id 保管單位
 * @param custody_user_id 保管人
 * @param orderer_customer_name 訂購人
 * @param receivable_amount 應收總金額
 * @param actual_pay_price 實際繳入總金額
 * @param predict_balance 預估餘款
 * @param predict_recovery_date 預計回收日
 * @param predict_delivery_date 預計交車日
 * @param invoice_date 發票日期
 * @param note 備註
 * @param delivery_note 交車備註
 * @param page 頁碼
 * @param num_per_page 一頁幾筆
 * @param excel 是否匯出
 */
export interface OrderNewCarReceivableReportParams {
    order_number?: string;
    autodms_order_number?: string;
    custody_unit_id?: string;
    custody_user_id?: string;
    orderer_customer_name?: string;
    receivable_amount?: number;
    actual_pay_price?: number;
    predict_balance?: number;
    predict_recovery_date?: string;
    predict_delivery_date?: string;
    invoice_date?: string;
    note?: string;
    delivery_note?: string;
    page?: number;
    num_per_page?: number;
    excel?: string;
}

/**
 * @description 新車應收報表 (回傳)
 * @param cre_time 建立時間
 * @param order_number 訂單編號
 * @param autodms_order_number AutoDMS訂單號碼
 * @param custody_unit_id 保管單位
 * @param custody_unit_name 保管單位名稱
 * @param custody_user_id 保管人
 * @param user_id 使用者ID
 * @param custody_user_name 保管人姓名
 * @param orderer_customer_name 訂購人
 * @param invoice_price_sum 發票總金額
 * @param receivable_amount 應收總金額
 * @param actual_pay_price 實際繳入總金額
 * @param predict_balance 預估餘款
 * @param predict_recovery_date 預計回收日
 * @param predict_delivery_date 預計交車日
 * @param invoice_date 發票日期
 * @param note 備註
 * @param delivery_note 交車備註
 */
export interface OrderNewCarReceivableReportResItem {
    cre_time?: string;
    order_number?: string;
    autodms_order_number?: string;
    custody_unit_id?: string;
    custody_unit_name?: string;
    custody_user_id?: string;
    user_id?: string;
    custody_user_name?: string;
    orderer_customer_name?: string;
    invoice_price_sum?: number;
    receivable_amount?: number;
    actual_pay_price?: number;
    predict_balance?: number;
    predict_recovery_date?: string;
    predict_delivery_date?: string;
    invoice_date?: string;
    note?: string;
    delivery_note?: string;
}

/** 訂單受訂送審 (參數)
 * @param order_id 訂單流水號
 * @param OODS 超折申請物件
 * @param is_OODS 是否超折來的
 */
export interface OrderSubscribeSubmitParams {
    order_id: string;
    OODS?: OrderOverDiscountSubmitParams;
    is_OODS: boolean;
}

/** 訂單超折申請 (參數)
 * @param order_id 訂單流水號
 * @param over_discount_price 超折申請
 * @param PR_bonus_user_id 公關車交車獎金領受人
 * @param PR_bonus_price 公關車交車獎金
 * @param over_discount_note 超折備註
 */
export interface OrderOverDiscountSubmitParams {
    order_id: string;
    over_discount_price?: number;
    PR_bonus_user_id?: string;
    PR_bonus_price?: number;
    over_discount_note?: string;
}

/** 審核訂單受訂 (參數)
 * @param token token
 * @param order_id 訂單流水號
 * @param status 審核狀態
 * @param note 備註
 * @param apd_id 稽核流程細項ID (dotnet6用)
 */
export interface OrderSubscribeAuditParams {
    token?: string;
    order_id: string;
    status: string;
    note?: string;
    apd_id?: string;
}

// ==================== 回傳型別 ====================

/** 訂單配發紀錄查詢 (回傳)
 * @param allotment_time 最近配發日
 * @param min_order_number 最小序號
 * @param max_order_number 最大序號
 * @param total_count 持有數
 * @param blank_count 空白數
 * @param used_count 使用數
 * @param abnormal_count 異常數
 */
export interface OrderAllotmentLogSearchResItem {
    allotment_time?: string;
    min_order_number?: number;
    max_order_number?: number;
    total_count?: number;
    blank_count?: number;
    used_count?: number;
    abnormal_count?: number;
}

/** 訂單保管查詢 個人統計 (回傳)
 * @param unit_name 單位
 * @param custody_user_id 保管人ID
 * @param name 保管人姓名
 * @param latest_allotment_time 最近配發日
 * @param min_order_number 最小序號
 * @param max_order_number 最大序號
 * @param total_count 持有數
 * @param blank_count 空白數
 * @param used_count 使用數
 * @param abnormal_count 異常數
 */
export interface OrderCustodyUserStatistic {
    unit_name?: string;
    custody_user_id?: string;
    name?: string;
    latest_allotment_time?: string;
    min_order_number?: number;
    max_order_number?: number;
    total_count?: number;
    blank_count?: number;
    used_count?: number;
    abnormal_count?: number;
}

/** 訂單保管查詢 單位統計 (回傳)
 * @param unit_name 單位名稱
 * @param name 名稱
 * @param latest_allotment_time 最近配發日
 * @param min_order_number 最小序號
 * @param max_order_number 最大序號
 * @param total_count 持有數
 * @param blank_count 空白數
 * @param used_count 使用數
 * @param abnormal_count 異常數
 */
export interface OrderCustodyUnitStatistic {
    unit_name?: string;
    name?: string;
    latest_allotment_time?: string;
    min_order_number?: number;
    max_order_number?: number;
    total_count?: number;
    blank_count?: number;
    used_count?: number;
    abnormal_count?: number;
}

/** 訂單保管查詢 (回傳)
 * @param user_statistics 個人統計
 * @param unit_statistics 單位統計
 */
export interface OrderCustodySearchResItem {
    user_statistics?: OrderCustodyUserStatistic[];
    unit_statistics?: OrderCustodyUnitStatistic[];
}

/** 訂單保管異動紀錄查詢 (回傳)
 * @param ocl_id 保管紀錄流水號
 * @param order_id 訂單流水號
 * @param custodyfrom_unit_id 來源保管單位流水號
 * @param custodyfrom_unit_name 來源保管單位名稱
 * @param custodyfrom_user_id 來源保管人流水號
 * @param custodyfrom_user_name 來源保管人姓名
 * @param custodyto_unit_id 目標保管單位流水號
 * @param custodyto_unit_name 目標保管單位名稱
 * @param custodyto_user_id 目標保管人流水號
 * @param custodyto_user_name 目標保管人姓名
 */
export interface OrderCustodyLogSearchResItem {
    ocl_id?: number;
    order_id?: string;
    custodyfrom_unit_id?: string;
    custodyfrom_unit_name?: string;
    custodyfrom_user_id?: string;
    custodyfrom_user_name?: string;
    custodyto_unit_id?: string;
    custodyto_unit_name?: string;
    custodyto_user_id?: string;
    custodyto_user_name?: string;
}

/** 稽核流程細項 (回傳) */
export interface SearchAuditProcedureDetailResItem {
    cre_userid?: string;
    cre_time?: string;
    upd_userid?: string;
    upd_time?: string;
    apd_id?: string;
    apm_id?: string;
    ul_id?: number;
    ul_code?: string;
    ul_name?: string;
    ds_id?: number;
    ds_code?: string;
    ds_name?: string;
    user_id?: string;
    user_cre_time?: string;
    user_username?: string;
    user_name?: string;
    audit_time?: string;
    status?: string;
    note?: string;
    leave_special_userlevel?: string;
    audit_breakpoint_level?: number;
    is_audit_breakpoint?: string;
    level?: number;
    audit_type?: string;
}

/** 訂單配件明細 (回傳)
 * @param occ_id 流水號
 * @param order_id 訂單流水號
 * @param component_name 配件名稱
 * @param price 單價
 * @param count 數量
 * @param stock_id 庫存流水號
 * @param commodity_id 配件流水號
 * @param label_big 配件大分類流水號
 * @param uc_id 單位轉換流水號
 * @param ccad_id_1 屬性細項1流水號
 * @param ccad_id_2 屬性細項2流水號
 * @param need_calc_stock 是否計算庫存
 * @param transaction_pay_price 計入交易車價
 * @param deductible_pay_price 自費金額
 * @param company_pay_price 公司付金額
 * @param headquarters_pay_price 總公司付金額
 * @param note 備註
 * @param commodity_code 配件代碼
 * @param convert_unit_id 轉換單位流水號
 * @param convert_unit_name 轉換單位名稱
 * @param convert_count 轉換數量
 * @param basic_unit_id 基本單位流水號
 * @param basic_unit_name 基本單位名稱
 * @param basic_count 基本數量
 * @param ccad_name_1 屬性細項1名稱
 * @param ccam_id_1 屬性主項1流水號
 * @param ccam_name_1 屬性主項1名稱
 * @param ccad_name_2 屬性細項2名稱
 * @param ccam_id_2 屬性主項2流水號
 * @param ccam_name_2 屬性主項2名稱
 * @param warehouse_master_id 倉庫主檔流水號
 * @param warehouse_name 倉庫名稱
 * @param warehouse_storage_space 儲位名稱
 */
export interface OrderCarComponentDetailResItem {
    occ_id?: number;
    order_id?: string;
    component_name?: string;
    price?: number;
    count?: number;
    stock_id?: string;
    commodity_id?: string;
    label_big?: string;
    uc_id?: string;
    ccad_id_1?: string;
    ccad_id_2?: string;
    need_calc_stock?: string;
    transaction_pay_price?: number;
    deductible_pay_price?: number;
    company_pay_price?: number;
    headquarters_pay_price?: number;
    note?: string;
    commodity_code?: string;
    convert_unit_id?: string;
    convert_unit_name?: string;
    convert_count?: number;
    basic_unit_id?: string;
    basic_unit_name?: string;
    basic_count?: number;
    ccad_name_1?: string;
    ccam_id_1?: string;
    ccam_name_1?: string;
    ccad_name_2?: string;
    ccam_id_2?: string;
    ccam_name_2?: string;
    warehouse_master_id?: string;
    warehouse_name?: string;
    warehouse_storage_space?: string;
}

/** 訂單入金明細 (回傳)
 * @param upd_userid 更新人帳號
 * @param username 更新人姓名
 * @param name 姓名
 * @param upd_time 更新時間
 * @param op_id 流水號
 * @param order_id 訂單流水號
 * @param isdeposit 是否訂金
 * @param payment 付款方式
 * @param transfer_out_bank 匯款轉出銀行
 * @param transfer_out_account 匯款轉出帳號
 * @param transfer_in_bank 匯款轉入銀行
 * @param transfer_in_account 匯款轉入帳號
 * @param transfer_in_date 匯款轉入日期
 * @param transfer_in_price 匯款入金金額
 * @param check_pay_bank 支票付款銀行
 * @param check_number 支票票號
 * @param check_receive_bank 支票貸收銀行
 * @param check_receive_date 支票貸收日期
 * @param check_expired_date 支票到期日
 * @param check_price 支票入金金額
 * @param swipe_in_bank 刷卡轉入銀行
 * @param swipe_in_account 刷卡轉入帳號
 * @param swipe_price 刷卡入金金額
 * @param swipe_handling_fee 刷卡手續費
 * @param innertransfer_out_bank 內轉轉出銀行
 * @param innertransfer_out_date 內轉轉出日期
 * @param innertransfer_out_price 內轉轉出金額
 * @param innertransfer_out_method 內轉轉出方式
 * @param innertransfer_summon_code 內轉轉出傳票號碼
 * @param note 備註
 * @param is_accounting 是否會計
 * @param overcharge 溢收
 * @param loan_tenure 貸款期數
 * @param loan_agency 貸款機構
 * @param loan_predict_subsidy_price 貸款預計補貼息
 * @param loan_bank_insurance_date 貸款銀行預計對保日期
 * @param loan_bank_predict_price 貸款預計金額
 * @param loan_company_subsidy_price 貸款公司補助補貼息
 * @param sales_advisor_loan_subsidy 銷顧獎金補貸款補貼息
 */
export interface OrderPaymentDetailResItem {
    upd_userid?: string;
    username?: string;
    name?: string;
    upd_time?: string;
    op_id?: number;
    order_id?: string;
    isdeposit?: string;
    payment?: string;
    transfer_out_bank?: string;
    transfer_out_account?: string;
    transfer_in_bank?: string;
    transfer_in_account?: string;
    transfer_in_date?: string;
    transfer_in_price?: number;
    check_pay_bank?: string;
    check_number?: string;
    check_receive_bank?: string;
    check_receive_date?: string;
    check_expired_date?: string;
    check_price?: number;
    swipe_in_bank?: string;
    swipe_in_account?: string;
    swipe_price?: number;
    swipe_handling_fee?: number;
    innertransfer_out_bank?: string;
    innertransfer_out_date?: string;
    innertransfer_out_price?: number;
    innertransfer_out_method?: string;
    innertransfer_summon_code?: string;
    note?: string;
    is_accounting?: string;
    overcharge?: number;
    loan_tenure?: string;
    loan_agency?: string;
    loan_predict_subsidy_price?: number;
    loan_bank_insurance_date?: string;
    loan_bank_predict_price?: number;
    loan_company_subsidy_price?: number;
    sales_advisor_loan_subsidy?: number;
}

/** 訂單保險明細 (回傳)
 * @param oi_id 流水號
 * @param order_id 訂單流水號
 * @param insurance_id 保險流水號
 * @param insurance_name 保險名稱
 * @param insurance_type 保險種類
 * @param insurance_type_name 保險種類名稱
 * @param insurance_company_id 保險公司流水號
 * @param insurance_company_code 保險公司代號
 * @param insurance_company_name 保險公司名稱
 * @param note 備註
 */
export interface OrderInsuranceDetailResItem {
    oi_id?: number;
    order_id?: string;
    insurance_id?: string;
    insurance_name?: string;
    insurance_type?: string;
    insurance_type_name?: string;
    insurance_company_id?: string;
    insurance_company_code?: string;
    insurance_company_name?: string;
    note?: string;
}

/** 訂單發票明細 (回傳)
 * @param oi_id 發票流水號
 * @param order_id 訂單流水號
 * @param invoice_price 發票金額
 * @param invoice_number 發票號碼
 * @param invoice_date 發票日期
 */
export interface OrderInvoiceDetailResItem {
    oi_id?: number;
    order_id?: string;
    invoice_price?: number;
    invoice_number?: string;
    invoice_date?: string;
}

/** 訂單車補助細項明細 (回傳)
 * @param ocsd_id 訂單車補助細項流水號
 * @param order_id 訂單流水號
 * @param csc_id 車補助條件流水號
 * @param csd_id 車補助細項流水號
 * @param csm_id 車補助主項流水號
 * @param cs_id 車庫存流水號
 * @param documet_source 文案來源
 * @param category 分類
 * @param type 類型
 * @param name 品項
 * @param abnormal_sale_type 異常銷售種類
 * @param deductible 可折不可折
 * @param price 金額
 * @param label_big 配件類型流水號
 * @param commodity_id 配件流水號
 * @param uc_id 單位轉換流水號
 * @param insurance_type 保險種類
 * @param upd_time 更新時間
 * @param first_submit_time 首次送審時間
 * @param licensed_date 領牌日期
 */
export interface OrderCarSubsidyDetailResItem {
    ocsd_id?: number;
    order_id?: string;
    csc_id?: string;
    csd_id?: number;
    csm_id?: string;
    cs_id?: string;
    documet_source?: string;
    category?: string;
    type?: string;
    name?: string;
    abnormal_sale_type?: string;
    deductible?: string;
    price?: number;
    label_big?: string;
    commodity_id?: string;
    uc_id?: string;
    insurance_type?: string;
    upd_time?: string;
    first_submit_time?: string;
    licensed_date?: string;
}

/** 訂單主檔明細 (回傳) */
export interface OrderMainDetailResItem {
    cre_userid?: string;
    cre_time?: string;
    upd_userid?: string;
    upd_time?: string;
    order_id?: string;
    order_number?: string;
    autodms_order_number?: string;
    order_process?: string;
    order_status?: string;
    contract_date?: string;
    custody_unit_id?: string;
    custody_user_id?: string;
    predict_licensed_date?: string;
    is_licensed_check?: string;
    licensed_check_time?: string;
    licensed_check_endorse_user_id?: string;
    licensed_date?: string;
    license_plate?: string;
    extraction_date?: string;
    predict_delivery_date?: string;
    delivery_date?: string;
    is_release_check?: string;
    release_check_time?: string;
    release_check_endorse_user_id?: string;
    isabnormal?: string;
    abnormal_return_status?: string;
    abnormal_return_note?: string;
    abnormal_return_time?: string;
    audit_status?: string;
    audit_note?: string;
    audit_time?: string;
    order_allotment_id?: number;
    allotment_time?: string;
    ocl_id?: number;
    potential_is_orderer?: string;
    potential_customer_id?: string;
    orderer_customer_name?: string;
    orderer_identity_number?: string;
    orderer_cellphone?: string;
    orderer_address_contact?: string;
    orderer_birthday?: string;
    orderer_email?: string;
    licenser_is_orderer?: string;
    licenser_customer_name?: string;
    licenser_identity_number?: string;
    licenser_cellphone?: string;
    licenser_address_contact?: string;
    licenser_birthday?: string;
    licenser_email?: string;
    user_is_orderer?: string;
    user_customer_name?: string;
    user_identity_number?: string;
    user_cellphone?: string;
    user_address_contact?: string;
    user_birthday?: string;
    user_email?: string;
    cs_id?: string;
    ct_id?: number;
    ctf_id?: number;
    ctfp_id?: number;
    ctep_id?: number;
    ctip_id?: number;
    car_type?: string;
    format_code?: string;
    format_name?: string;
    year?: number;
    year_age?: number;
    exterior_code?: string;
    exterior_color?: string;
    interior_code?: string;
    interior_color?: string;
    car_type_price?: number;
    repayment_price?: number;
    exterior_price?: number;
    exterior_cost?: number;
    interior_price?: number;
    interior_cost?: number;
    cash_subsidy_deductible?: number;
    cash_subsidy_nondeductible?: number;
    component_price_sum?: number;
    component_subsidy_deductible_sum?: number;
    component_subsidy_nondeductible_sum?: number;
    component_own_expense_sum?: number;
    insurance_price?: number;
    insurance_company?: string;
    insurance_fee_overflow?: number;
    insurance_processing_fee_overflow?: number;
    predict_pay_price?: number;
    actual_pay_price?: number;
    system_pay_price?: number;
    company_rule?: number;
    deposit_sum?: number;
    cash_subsidy_deductible_sum?: number;
    loan_agency?: string;
    loan_bank_insurance_date?: string;
    loan_bank_predict_price?: number;
    loan_predict_subsidy_price?: number;
    loan_company_subsidy_price?: number;
    predict_balance?: number;
    promotion_condition_sum?: number;
    predict_actual_condition_sum?: number;
    actual_actual_condition_sum?: number;
    predict_difference_price?: number;
    actual_difference_price?: number;
    cash_nondeductible?: number;
    over_discount_price?: number;
    PR_bonus_user_id?: string;
    PR_bonus_price?: number;
    over_discount_note?: string;
    over_discount_price_sum?: number;
    note?: string;
    delivery_note?: string;
    abnormal_sale_type?: string;
    is_dispatched?: string;
    dispatch_car_time?: string;
    stop_dispatch?: string;
    is_car_limit?: string;
    is_self_licensed?: string;
    is_accounting_check?: string;
    accounting_check_time?: string;
    is_invoice_check?: string;
    invoice_check_time?: string;
    first_submit_time?: string;
    first_audit_time?: string;
    cus_agree_time?: string;
    final_payment_time?: string;
    final_payment_check_time?: string;
    is_final_payment_check?: string;
    sales_advisor_loan_subsidy?: number;
    predict_recovery_date?: string;
    custody_user_name?: string;
    custody_username?: string;
    custody_user_cre_time?: string;
    custody_ul_id?: number;
    custody_ul_name?: string;
    custody_position_id?: string;
    custody_position_name?: string;
    custody_class_id?: string;
    custody_class_name?: string;
    licensed_check_endorse_user_name?: string;
    licensed_check_endorse_username?: string;
    licensed_check_endorse_user_cre_time?: string;
    release_check_endorse_user_name?: string;
    release_check_endorse_username?: string;
    release_check_endorse_user_cre_time?: string;
    potential_customer_cre_time?: string;
    potential_customer_name?: string;
    PR_bonus_user_name?: string;
    PR_bonus_username?: string;
    PR_bonus_user_cre_time?: string;
    custody_unit_name?: string;
    apm_id?: string;
    AuditDetails?: SearchAuditProcedureDetailResItem[];
    audit_level?: string;
    audit_level_ul_id?: number;
    SIDO_no?: string;
    vin_no?: string;
    store_department?: string;
    potential_customer_outer_id?: string;
    potential_customer_source?: string;
    potential_customer_source_name?: string;
    potential_customer_level?: string;
    potential_customer_level_name?: string;
    potential_customer_cellphone?: string;
    potential_customer_address_contact?: string;
    invoice_price_sum?: number;
    receivable_amount?: number;
    total_amount?: number;
}

/** 訂單細項 (回傳)
 * @param dt 訂單主檔明細
 * @param dt_order_components 訂單配件明細
 * @param dt_order_payment 訂單入金明細
 * @param dt_order_insurance 訂單保險
 * @param dt_order_invoice 訂單發票
 * @param dt_order_subsidy 訂單補助
 */
export interface OrderDetailResItem {
    dt?: OrderMainDetailResItem;
    dt_order_components?: OrderCarComponentDetailResItem[];
    dt_order_payment?: OrderPaymentDetailResItem[];
    dt_order_insurance?: OrderInsuranceDetailResItem[];
    dt_order_invoice?: OrderInvoiceDetailResItem[];
    dt_order_subsidy?: OrderCarSubsidyDetailResItem[];
}

/** 訂單配車查詢 (回傳)
 * @param cs_id 車庫存流水號
 * @param ctfp_id 車型規格定價流水號
 * @param ctep_id 車型外裝加價流水號
 * @param ctip_id 車型內裝加價流水號
 * @param SIDO_no SIDO號碼
 * @param vin_no 車身碼
 * @param leave_factory_date 出廠日期
 * @param position_name 車位名稱
 * @param position_id 車位ID
 * @param cwm_name 車庫名稱
 * @param cwm_id 車庫ID
 * @param cwd_name 車庫區名稱
 * @param cwd_id 車庫區ID
 */
export interface OrderDispatchCarSearchResItem {
    cs_id?: string;
    ctfp_id?: number;
    ctep_id?: number;
    ctip_id?: number;
    SIDO_no?: string;
    vin_no?: string;
    leave_factory_date?: string;
    position_name: string;
    position_id: string;
    cwm_name: string;
    cwm_id: string;
    cwd_name: string;
    cwd_id: string;
}

/** 訂單配車 (回傳)
 * @param cs_id 車流水號
 * @param SIDO_no SIDO號碼
 * @param vin_no 車身碼
 * @param is_dispatched 是否已配車
 * @param dispatch_car_time 配車時間
 */
export interface OrderDispatchCarResItem {
    cs_id?: string;
    SIDO_no?: string;
    vin_no?: string;
    is_dispatched?: string;
    dispatch_car_time?: string;
}

/** 訂單暫停配對 (回傳)
 * @param cs_id 車流水號
 * @param SIDO_no SIDO號碼
 * @param vin_no 車身碼
 */
export interface OrderStopDispatchResItem {
    cs_id?: string;
    SIDO_no?: string;
    vin_no?: string;
}

/** 訂單車型庫存搜尋 (回傳)
 * @param cs_id 車庫存流水號
 * @param SIDO_no 車身碼
 * @param vin_no 車架號碼
 * @param license_plate 車牌號碼
 */
export interface OrderCarStockSearchResItem {
    cs_id?: string;
    SIDO_no?: string;
    vin_no?: string;
    license_plate?: string;
}

/** 補助條件檢查物件 (回傳) */
export interface CarSubsidyConditionCheckResItem {
    csc_id?: string;
    csd_id?: number;
    csm_id?: string;
    ct_id?: number;
    ctf_id?: number;
    year?: number;
    year_age?: number;
    cs_id?: string;
    documet_source?: string;
    category?: string;
    type?: string;
    name?: string;
    associate_type?: string;
    associate_csc_ids?: string[];
    abnormal_sale_type?: string;
    deductible?: string;
    price_source_csc_id?: string;
    discount?: number;
    price?: number;
    commodity_cost?: number;
    diff_price?: number;
    visible?: string;
    label_big?: string;
    commodity_id?: string;
    uc_id?: string;
    insurance_type?: string;
    ischeck?: boolean;
    isvalid?: boolean;
}

/** 計算補助(不更新訂單) (回傳)
 * @param cash_subsidy_deductible 現金補助可折
 * @param cash_subsidy_nondeductible 現金補助不可折
 * @param component_subsidy_deductible_sum 配件補助可折總額
 * @param component_subsidy_nondeductible_sum 配件補助不可折總額
 * @param component_own_expense_sum 配件自付額總額
 * @param loan_company_subsidy_price 貸款公司補助補貼息
 * @param list 補助條件檢查清單
 * @param loop_count 迴圈計數
 */
export interface OrderCalculateSubsidyBeforeUpdateResItem {
    cash_subsidy_deductible: number;
    cash_subsidy_nondeductible: number;
    component_subsidy_deductible_sum: number;
    component_subsidy_nondeductible_sum: number;
    component_own_expense_sum: number;
    loan_company_subsidy_price: number;
    list?: CarSubsidyConditionCheckResItem[];
    loop_count: number;
}

/** 訂單補助車輛查詢 (回傳)
 * @param cs_id 車流水號
 * @param SIDO_no SIDO號碼
 * @param vin_no 車身碼
 * @param license_plate 車牌號碼
 * @param position_name 車位名稱
 * @param position_id 車位ID
 * @param cwm_name 車庫名稱
 * @param cwm_id 車庫ID
 * @param cwd_name 車庫區名稱
 * @param cwd_id 車庫區ID
 */
export interface OrderSubsidyCarSearchResItem {
    cs_id: string;
    SIDO_no: string;
    vin_no: string;
    license_plate: string;
    position_name: string;
    position_id: string;
    cwm_name: string;
    cwm_id: string;
    cwd_name: string;
    cwd_id: string;
}

/** 放行前檢查項目 (回傳)
 * @param check_item 檢查項目
 * @param is_passed 是否通過
 */
export interface OrderBeforeReleaseCheckItemResItem {
    check_item?: string;
    is_passed?: boolean;
}

/** 訂單受訂完成放行前檢查 (回傳)
 * @param check_items 檢查項目清單
 */
export interface OrderBeforeReleaseCheckResItem {
    check_items?: OrderBeforeReleaseCheckItemResItem[];
}

/** 訂單確認領牌 (回傳)
 * @param is_licensed_check 是否確認領牌
 * @param licensed_check_time 領牌確認時間
 * @param licensed_check_endorse_user_id 領牌背書人ID
 * @param licensed_check_endorse_user_name 領牌背書人姓名
 */
export interface OrderLicensedCheckResItem {
    is_licensed_check?: string;
    licensed_check_time?: string;
    licensed_check_endorse_user_id?: string;
    licensed_check_endorse_user_name?: string;
}

/** 訂單確認放行 (回傳)
 * @param is_release_check 是否確認放行
 * @param release_check_time 放行確認時間
 * @param release_check_endorse_user_id 放行背書人ID
 * @param release_check_endorse_user_name 放行背書人姓名
 */
export interface OrderReleaseCheckResItem {
    is_release_check?: string;
    release_check_time?: string;
    release_check_endorse_user_id?: string;
    release_check_endorse_user_name?: string;
}

/** 訂單更新領牌資訊 (回傳)
 * @param licensed_date 領牌日期
 * @param license_plate 車牌號碼
 * @param cs_id 車流水號
 */
export interface OrderUpdateLicensedInfoResItem {
    licensed_date?: string;
    license_plate?: string;
    cs_id?: string;
}

/** 新車訂單報表 (回傳)
 * @param autodms_order_number AutoDMS訂單號碼
 * @param custody_name 申請者姓名
 * @param final_payment_check_status 財務全款狀態
 * @param first_audit_date 審核通過日期
 * @param first_submit_time 申請時間
 * @param licensed_date 領牌日期
 * @param final_licensed_date 實際領牌日期
 * @param order_number 訂單編號
 * @param order_status 審核狀態
 * @param final_payment_time 全款日期
 */
export interface OrderDetailReportResItem {
    autodms_order_number: string;
    custody_name: string;
    final_payment_check_status: string;
    first_audit_date: string;
    first_submit_time: string;
    licensed_date: string;
    final_licensed_date: string;
    order_number: string;
    order_status: string;
    final_payment_time: string;
}

/** 新車配件報表 (回傳)
 * @param order_id 訂單ID
 * @param order_number 訂單編號
 * @param final_payment_time 全款日期
 * @param first_audit_time 初次審核通過時間
 * @param car_type_name 車型名稱
 * @param custody_unit_name 保管單位
 * @param label_big_content 配件大標籤名稱
 * @param label_mid_content 配件中標籤名稱
 * @param label_small_content 配件小標籤名稱
 * @param commodity_name 配件(商品)名稱
 * @param ordercarcomponent_price 訂單配件價格
 * @param ordercarcomponent_count 訂單配件數量
 * @param totalprice 合計金額
 * @param final_licensed_date 實際領牌日期
 */
export interface OrderReportResItem {
    order_id?: string;
    order_number?: string;
    final_payment_time?: string;
    first_audit_time?: string;
    car_type_name?: string;
    custody_unit_name?: string;
    label_big_content?: string;
    label_mid_content?: string;
    label_small_content?: string;
    commodity_name?: string;
    ordercarcomponent_price?: number;
    ordercarcomponent_count?: number;
    totalprice?: number;
    final_licensed_date?: string;
}
